<template>
  <div class="svgCon">
    <div style="width: 100%; height: 100%; margin: auto">
      <svg id="svgc" style="width: 100%; height: 100%" />
    </div>
    <select-box v-if="initFlag" @lightCity="lightCity" @lightRoad="lightRoad" @allClear="allClear"></select-box>
    <div class="menu_box">
      <div class="aside" flag="0">
        <!-- <div>
              <img src="../assets/img/maps.png" alt="">
              <p>地图</p>
          </div>
        <div style="height:1px;width:80%;margin:7px auto;background:#D8D8D8"></div>-->
        <div id="lukuangCon" @click="luFun">
          <img src="../assets/img/lkuang.png" alt v-show="!qixiangFlag" />
          <img src="../assets/img/wulu.png" alt v-show="qixiangFlag" />
          <p>路况</p>
        </div>
        <!-- <div style="height:1px;width:60%;margin:7px auto;background:#D8D8D8"></div>
        <div class="qixiang" @click="changQiX">
          <img src="../assets/img/qiwu.png" alt v-show="!qixiangFlag" />
          <img src="../assets/img/qiyou.png" alt v-show="qixiangFlag" />
          <p>气象</p>
        </div> -->
        <div style="
            height: 0.01rem;
            width: 60%;
            margin: 0.07rem auto;
            background: #d8d8d8;
          "></div>
        <!-- <div>
            <img src="../assets/img/yuce.png" alt="">
            <p>交通预测</p>
          </div>
        <div style="height:1px;width:60%;margin:7px auto;background:#D8D8D8"></div>-->
        <div @click="fujinFun">
          <img src="../assets/img/nears.png" alt />
          <p>附近</p>
        </div>
        <div style="
            height: 0.01rem;
            width: 60%;
            margin: 0.07rem auto;
            background: #d8d8d8;
          "></div>
        <!-- <div @click="exportPng">
          <img src="../assets/img/down.png" alt />
          <p>导出</p>
        </div> -->
        <!-- <div style="height:1px;width:60%;margin:7px auto;background:#D8D8D8"></div>
          <div>
              <img src="../assets/img/dingz.png" alt="">
              <p>定制服务</p>
        </div>-->
      </div>
      <div v-show="lkFlag" class="aside_menuBG" @click.prevent.stop="lkFlag = false"></div>
      <div class="aside_menu" v-show="lkFlag">
        <div class="accident">
          <div class="title">事件</div>
          <ul>
            <li @click="thingChange(shiguFlag, 1006301, 'shiguFlag')">
              <img src="../assets/img/img01_active.png" alt v-show="shiguFlag" />
              <img src="../assets/img/img01.png" alt v-show="!shiguFlag" />
              <p>事故</p>
            </li>
            <li @click="thingChange(zuFlag, 1006302, 'zuFlag')">
              <img src="../assets/img/img02_active.png" alt v-show="zuFlag" />
              <img src="../assets/img/img02.png" alt v-show="!zuFlag" />
              <p>阻塞</p>
            </li>
            <li @click="thingChange(guanFlag, 1006303, 'guanFlag')">
              <img src="../assets/img/img03_active.png" alt v-show="guanFlag" />
              <img src="../assets/img/img03.png" alt v-show="!guanFlag" />
              <p>管制</p>
            </li>
            <!-- <li @click="thingChange(jianyiFlag, 1006106, 'jianyiFlag')">
              <img
                src="../assets/img/jianyi_active.png"
                alt
                v-show="jianyiFlag"
              />
              <img
                src="../assets/img/jianyi_default.png"
                alt
                v-show="!jianyiFlag"
              />
              <p>检疫</p>
            </li> -->
          </ul>
        </div>
        <div class="sg">
          <div class="title">施工</div>
          <ul>
            <li @click="thingChange(gongingFlag, 1006002, 'gongingFlag')">
              <img src="../assets/img/img04_active.png" alt v-show="gongingFlag" />
              <img src="../assets/img/img04.png" alt v-show="!gongingFlag" />
              <p>正在施工</p>
            </li>
            <li @click="thingChange(gongjiFlag, 1006003, 'gongjiFlag')">
              <img src="../assets/img/img05_active.png" alt v-show="gongjiFlag" />
              <img src="../assets/img/img05.png" alt v-show="!gongjiFlag" />
              <p>施工计划</p>
            </li>
            <li></li>
          </ul>
        </div>
        <div class="station">
          <div class="title">收费站</div>
          <ul>
            <li @click="stationChange(feizhengFlag, '正常', 'feizhengFlag')">
              <img src="../assets/img/img06_active.png" alt v-show="feizhengFlag" />
              <img src="../assets/img/img06.png" alt v-show="!feizhengFlag" />
              <p>正常</p>
            </li>
            <!-- <li @click="stationChange(feifengFlag, '封闭', 'feifengFlag')">
              <img
                src="../assets/img/img07_active.png"
                alt
                v-show="feifengFlag"
              />
              <img src="../assets/img/img07.png" alt v-show="!feifengFlag" />
              <p>封闭</p>
            </li> -->
            <li @click="
              stationChange(unidirectionFlag, '单向封闭', 'unidirectionFlag')
              ">
              <img src="../assets/img/unidirection_active.png" alt v-show="unidirectionFlag" />
              <img src="../assets/img/unidirection.png" alt v-show="!unidirectionFlag" />
              <p>单向关闭</p>
            </li>
            <li @click="
              stationChange(bidirectionFlag, '双向封闭', 'bidirectionFlag')
              ">
              <img src="../assets/img/bidirection_active.png" alt v-show="bidirectionFlag" />
              <img src="../assets/img/bidirection.png" alt v-show="!bidirectionFlag" />
              <p>双向关闭</p>
            </li>
            <li @click="stationChange(feiguanFlag, '管制', 'feiguanFlag')">
              <img src="../assets/img/img08_active.png" alt v-show="feiguanFlag" />
              <img src="../assets/img/img08.png" alt v-show="!feiguanFlag" />
              <p>限制车型</p>
            </li>
          </ul>
        </div>
        <!-- <div class="facilities">
          <div class="title">设施</div>
          <ul>
            <li @click="monitorChange(dljkFlag, 2101006, 'dljkFlag')">
              <img src="../assets/img/img09_active.png" alt v-show="dljkFlag" />
              <img src="../assets/img/img09.png" alt v-show="!dljkFlag" />
              <p>道路监控</p>
            </li>
            <li @click="monitorChange(fwqjkFlag, 2101002, 'fwqjkFlag')">
              <img
                src="../assets/img/img10_active.png"
                alt
                v-show="fwqjkFlag"
              />
              <img src="../assets/img/img10.png" alt v-show="!fwqjkFlag" />
              <p>服务区监控</p>
            </li>
            <li @click="monitorChange(sfzjkFlag, 2101001, 'sfzjkFlag')">
              <img
                src="../assets/img/img11_active.png"
                alt
                v-show="sfzjkFlag"
              />
              <img src="../assets/img/img11.png" alt v-show="!sfzjkFlag" />
              <p>收费站监控</p>
            </li>
            <li @click="monitorChange(sdjkFlag, 2101004, 'sdjkFlag')">
              <img src="../assets/img/img12_active.png" alt v-show="sdjkFlag" />
              <img src="../assets/img/img12.png" alt v-show="!sdjkFlag" />
              <p>隧道监控</p>
            </li>
            <li @click="monitorChange(qljkFlag, 2101003, 'qljkFlag')">
              <img src="../assets/img/img13_active.png" alt v-show="qljkFlag" />
              <img src="../assets/img/img13.png" alt v-show="!qljkFlag" />
              <p>桥梁监控</p>
            </li>
            <li @click="monitorChange(mjjkFlag, 2101005, 'mjjkFlag')">
              <img src="../assets/img/img17_active.png" alt v-show="mjjkFlag" />
              <img src="../assets/img/img17.png" alt v-show="!mjjkFlag" />
              <p>门架监控</p>
            </li>
          </ul>
        </div> -->
        <div class="other">
          <div class="title">其它</div>
          <ul>
            <li @click="noFun">
              <img src="../assets/img/img14_active.png" alt v-show="meiFlag" />
              <img src="../assets/img/img14.png" alt v-show="!meiFlag" />
              <p>美食</p>
            </li>
            <li @click="noFun">
              <img src="../assets/img/img15_active.png" alt v-show="jingFlag" />
              <img src="../assets/img/img15.png" alt v-show="!jingFlag" />
              <p>景区</p>
            </li>
            <li class="fuwuqu" @click="fuwuChange(fuwuFlag, 'fuwuFlag')">
              <img src="../assets/img/img16_active.png" alt v-show="fuwuFlag" />
              <img src="../assets/img/img16.png" alt v-show="!fuwuFlag" />
              <p>服务区</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- <div class="qiTips" v-show="qiTipFlag">
      <div class="qiCon">
        <div class="titles">气象服务在这里</div>
        <div class="con">进入气象模式，在高速线路上选择您要查看天气的位置，即可查看天气情况哦</div>
        <div class="iknow" @click="iKnow">我知道了</div>
      </div>
      <div class="qiConBg">
        <img src="../assets/img/qitipBg.png" alt />
      </div>
      <div class="qiTipIcon">
        <img src="../assets/img/qitipIcon.png" alt style="width:46px;" />
      </div>
    </div> -->
    <!-- <div class="roadPlan" @click="toFastRoad">
      <div>路线规划</div>
    </div> -->
    <div class="scaleDing">
      <div style="
          position: absolute;
          bottom: 0.29rem;
          left: 0.04rem;
          width: 0.47rem;
          height: 0.47rem;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
        " @click="reLoadEven(true)">
        <img src="../assets/img/chongding.png" style="width: 100%" />
      </div>
      <div style="
          position: absolute;
          bottom: 0.78rem;
          left: 0.04rem;
          width: 0.47rem;
          height: 0.82rem;
          cursor: pointer;
        ">
        <img src="../assets/img/scallbs.png" style="width: 100%" />
        <div style="width: 100%; height: 50%; position: absolute; top: 0" @click="enlargeSVG()"></div>
        <div style="width: 100%; height: 50%; position: absolute; top: 50%" @click="narrowSVG()"></div>
      </div>
      <div class="reload" style="
          position: absolute;
          bottom: 1.62rem;
          left: 0.04rem;
          width: 0.47rem;
          height: 0.47rem;
          cursor: pointer;
        " @click="reloadF">
        <img src="../assets/img/reload.png" style="width: 100%" />
      </div>
    </div>
    <!-- 事件弹出层 -->
    <cube-popup type="my-popup" position="bottom" :mask-closable="true" ref="sjPopup" @mask-click="sjHide">
      <div class="cube-extend-popup-content">
        <slot>
          <div class="stationCon">
            <div class="titleCon">
              <div style="width: 0.38rem; height: 0.38rem">
                <img src="../assets/img/img01_active.png" alt v-show="sjDetialFrom.eventtype == 1006301" />
                <img src="../assets/img/img02_active.png" alt v-show="sjDetialFrom.eventtype == 1006302" />
                <img src="../assets/img/img03_active.png" alt v-show="sjDetialFrom.eventtype == 1006303" />
                <img src="../assets/img/img04_active.png" alt v-show="sjDetialFrom.eventtype == 1006002" />
                <img src="../assets/img/img05_active.png" alt v-show="sjDetialFrom.eventtype == 1006003" />
                <img src="../assets/img/jianyi_active.png" alt v-show="sjDetialFrom.eventtype == 1006106" />
              </div>
              <div class="sjName">
                <div>
                  <span class="sjNameText" v-show="sjDetialFrom.eventtype == 1006301">事故</span>
                  <span class="sjNameText" v-show="sjDetialFrom.eventtype == 1006302">阻塞</span>
                  <template v-if="sjDetialFrom.eventtype == 1006303">
                    <span class="sjNameText" v-if="sjDetialFrom.controltype == 1006402">双向管控</span>
                    <span class="sjNameText" v-else-if="sjDetialFrom.controltype == 1006403">入口管控</span>
                    <span class="sjNameText" v-else>{{
                      sjDetialFrom.controltypename
                    }}</span>
                  </template>
                  <span class="sjNameText" v-show="sjDetialFrom.eventtype == 1006106">检疫</span>
                  <span class="sjNameText" v-show="sjDetialFrom.eventtype == 1006002">正在施工</span>
                  <span class="sjNameText" v-show="sjDetialFrom.eventtype == 1006003">施工计划</span>

                  <span v-show="sjDetialFrom.status == 1008001" class="tipsty"
                    style="background: #128746; color: #fff">畅通</span>
                  <span v-show="sjDetialFrom.status == 1008002" class="tipsty"
                    style="background: #ffbb12; color: #fff">缓行</span>
                  <span v-show="sjDetialFrom.status == 1008003 &&
                    sjDetialFrom.eventtype != 1006303
                    " class="tipsty" style="background: #f76260; color: #fff">滞留</span>
                  <span v-show="sjDetialFrom.status == 1008004" class="tipsty"
                    style="background: #73859f; color: #fff">阻断</span>
                </div>
                <div class="address">
                  {{ sjDetialFrom.shortname }} {{ sjDetialFrom.directionname }}
                </div>
              </div>
              <div class="closePop" @click="sjHide">X</div>
            </div>
            <div class="mainCon">{{ sjDetialFrom.reportout }}</div>
            <div class="mainPot">
              <ul>
                <li>
                  <div class="valCon">{{ sjDetialFrom.nodestake }}</div>
                </li>
                <li v-show="sjDetialFrom.eventtype == 1006002 ||
                  sjDetialFrom.eventtype == 1006003
                  ">
                  <div class="valCon">{{ sjDetialFrom.occtime }}</div>
                </li>
                <li v-show="sjDetialFrom.eventtype != 1006002 &&
                  sjDetialFrom.eventtype != 1006003
                  ">
                  <div class="valCon">{{ sjDetialFrom.nodename }}</div>
                </li>
                <li v-show="sjDetialFrom.eventtype == 1006002 ||
                  sjDetialFrom.eventtype == 1006003
                  ">
                  <div class="valCon">{{ sjDetialFrom.duration }}</div>
                </li>
                <li v-show="sjDetialFrom.eventtype != 1006002 &&
                  sjDetialFrom.eventtype != 1006003
                  ">
                  <div class="valCon">{{ sjDetialFrom.track }}</div>
                </li>
                <li v-show="sjDetialFrom.eventtype == 1006002 ||
                  sjDetialFrom.eventtype == 1006003
                  ">
                  <div class="valCon">{{ sjDetialFrom.eventcausename }}</div>
                </li>
                <li v-show="sjDetialFrom.eventtype != 1006002 &&
                  sjDetialFrom.eventtype != 1006003
                  ">
                  <div class="valCon">{{ sjDetialFrom.slowmiles }}</div>
                </li>
              </ul>
              <ul>
                <li>
                  <div class="keyCon">桩号区间</div>
                </li>
                <li v-show="sjDetialFrom.eventtype == 1006002 ||
                  sjDetialFrom.eventtype == 1006003
                  ">
                  <div class="keyCon">开始时间</div>
                </li>
                <li v-show="sjDetialFrom.eventtype != 1006002 &&
                  sjDetialFrom.eventtype != 1006003
                  ">
                  <div class="keyCon">站点区间</div>
                </li>
                <li v-show="sjDetialFrom.eventtype == 1006002 ||
                  sjDetialFrom.eventtype == 1006003
                  ">
                  <div class="keyCon">持续时间</div>
                </li>
                <li v-show="sjDetialFrom.eventtype != 1006002 &&
                  sjDetialFrom.eventtype != 1006003
                  ">
                  <div class="keyCon">处理进度</div>
                </li>
                <li v-show="sjDetialFrom.eventtype == 1006002 ||
                  sjDetialFrom.eventtype == 1006003
                  ">
                  <div class="keyCon">施工方式</div>
                </li>
                <li v-show="sjDetialFrom.eventtype != 1006002 &&
                  sjDetialFrom.eventtype != 1006003
                  ">
                  <div class="keyCon">拥堵距离</div>
                </li>
              </ul>
            </div>
          </div>
        </slot>
      </div>
    </cube-popup>
    <!-- 收费站弹出层 -->
    <cube-popup type="my-popup" :zIndex="12" position="bottom" :mask-closable="true" ref="stationPopup"
      @mask-click="stationHide">
      <div class="cube-extend-popup-content">
        <slot>
          <div>
            <tollStationDetail ref="daohang" :showMoreStatus="true" @toStaDetial="toStaDetial(stationDeFrom)"
              :dataDetail="stationDeFrom" />
          </div>
        </slot>
      </div>
    </cube-popup>

    <div
      style="position: fixed;z-index: 100;bottom: 0px;left: 0px;width: 100%;height: 100vh;padding-top:25vh;box-sizing: border-box;"
      v-if="staDetialFlag" @click="staDetialFlag = false">
      <div @click.stop.prevent="staDetialFlag = true" style="position: relative;">
        <img @click="toKefu"
          style="position:absolute;right:.17rem;top:-.18rem;width: 0.48rem;height: .48rem;z-index: 100;"
          src="~@/assets/img/kefu1.png" />
        <div class=" stationCon1" ref="stationCons">
          <tollStationDetail1 ref="tollStationDetail" :dataDetail="stationDeFrom" />
          <div class="nearStation">
            <div class="nearStaTitle">附近可通行收费站</div>
            <ul>
              <li v-for="(item, index) in nearStaList" :key="index">
                <div>
                  <img :src="item.picurl" alt style="width: 0.53rem; height: 0.53rem" />
                </div>
                <div class="stationName">
                  <div class="stationNameText">{{ item.name }}
                    <span class="stationStatus"><span>正常</span></span>
                  </div>
                  <div class="staAddress">{{ item.address }}</div>

                </div>
                <div class="daohang" @click="toDao1(item)">
                  <img src="~@/assets/img/map.png" alt style="width: 0.18rem; height: 0.18rem" />
                  <div class="disCon">{{
                    Number(item.distance)
                      ? (Number(item.distance) / 1000).toFixed(2)
                      : 0
                  }}km
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- 收费站详情弹出层 -->
    <!-- <cube-popup type="my-popup" :zIndex='15' position="bottom" :mask-closable="true" ref="staDetialPopup" id='staDetialPopup' @mask-click='staDetialHide'> -->

    <!-- </cube-popup> -->
    <!-- 服务区详情弹出层 -->
    <cube-popup type="my-popup" :zIndex="12" position="bottom" :mask-closable="true" ref="fuwuPopup"
      @mask-click="fuwuHide">
      <div class="cube-extend-popup-content" style>
        <slot>
          <div class="fuwuCon">
            <div class="fuwuTitle">
              <div style="width: 0.5rem; margin-top: 0.1rem">
                <img :src="fuwuFrom.pic" style="width: 0.48rem; height: 0.48rem" />
              </div>
              <div class="stationName">
                <div>
                  <span style="font-weight: bolder">{{ fuwuFrom.name }}</span>
                  <span v-show="fuwuFrom.servicestatus == '1021001'" style="
                      background: rgba(238, 253, 242, 1);
                      color: #28a652;
                      padding: 0 0.06rem;
                      font-size: 0.11rem;
                    ">正常</span>
                  <span v-show="fuwuFrom.servicestatus != '1021001'" style="
                      background: #efeeee;
                      color: #999999;
                      padding: 0 0.06rem;
                      font-size: 0.11rem;
                    ">关闭</span>
                </div>
                <div>{{ fuwuFrom.roadname }}</div>
                <div>
                  {{
                    Number(fuwuFrom.distance)
                      ? Number(fuwuFrom.distance / 1000).toFixed(2)
                      : 0
                  }}km ▏{{ fuwuFrom.address }}
                </div>
              </div>
              <div class="daohang" @click="toDao(fuwuFrom)">
                <img src="../assets/img/goto.png" alt style="
                    width: 0.36rem;
                    height: 0.36rem;
                    margin-bottom: 0.01rem;
                  " />
                <div>到这去</div>
              </div>
            </div>
            <div class="fuwuMain">
              <div class="statusList">
                <div class="statusTitle">上行方向</div>
                <div class="statusItem">
                  <ul>
                    <li>
                      <div v-show="fuwuFrom.hasfood == 1">
                        <img src="../assets/img/fuyou1.png" alt />
                        <div>餐饮</div>
                      </div>
                      <div v-show="fuwuFrom.hasfood != 1">
                        <img src="../assets/img/fuwu1.png" alt />
                        <div style="color: #c8c8c8">餐饮</div>
                      </div>
                    </li>
                    <li>
                      <div v-show="fuwuFrom.hashotel == 1">
                        <img src="../assets/img/fuyou2.png" alt />
                        <div>住宿</div>
                      </div>
                      <div v-show="fuwuFrom.hashotel != 1">
                        <img src="../assets/img/fuwu2.png" alt />
                        <div style="color: #c8c8c8">住宿</div>
                      </div>
                    </li>
                    <li>
                      <div v-show="fuwuFrom.hasshop == 1">
                        <img src="../assets/img/fuyou3.png" alt />
                        <div>商店</div>
                      </div>
                      <div v-show="fuwuFrom.hasshop != 1">
                        <img src="../assets/img/fuwu3.png" alt />
                        <div style="color: #c8c8c8">商店</div>
                      </div>
                    </li>
                    <li>
                      <div v-show="fuwuFrom.hasgasstation == 1">
                        <img src="../assets/img/fuyou4.png" alt />
                        <div>加油</div>
                      </div>
                      <div v-show="fuwuFrom.hasgasstation != 1">
                        <img src="../assets/img/fuwu4.png" alt />
                        <div style="color: #c8c8c8">加油</div>
                      </div>
                    </li>
                    <li>
                      <div v-show="fuwuFrom.hastoilet == 1">
                        <img src="../assets/img/fuyou5.png" alt />
                        <div>卫生间</div>
                      </div>
                      <div v-show="fuwuFrom.hastoilet != 1">
                        <img src="../assets/img/fuwu5.png" alt />
                        <div style="color: #c8c8c8">卫生间</div>
                      </div>
                    </li>
                    <li>
                      <div v-show="fuwuFrom.hasrepair == 1">
                        <img src="../assets/img/fuyou6.png" alt />
                        <div>汽修</div>
                      </div>
                      <div v-show="fuwuFrom.hasrepair != 1">
                        <img src="../assets/img/fuwu6.png" alt />
                        <div style="color: #c8c8c8">汽修</div>
                      </div>
                    </li>
                    <li>
                      <div v-show="fuwuFrom.hasparking == 1">
                        <img src="../assets/img/fuyou7.png" alt />
                        <div>停车</div>
                      </div>
                      <div v-show="fuwuFrom.hasparking != 1">
                        <img src="../assets/img/fuwu7.png" alt />
                        <div style="color: #c8c8c8">停车</div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="statusList">
                <div class="statusTitle">下行方向</div>
                <div class="statusItem">
                  <ul>
                    <li>
                      <div v-show="fuwuFrom.hasfood2 == 1">
                        <img src="../assets/img/fuyou1.png" alt />
                        <div>餐饮</div>
                      </div>
                      <div v-show="fuwuFrom.hasfood2 != 1">
                        <img src="../assets/img/fuwu1.png" alt />
                        <div style="color: #c8c8c8">餐饮</div>
                      </div>
                    </li>
                    <li>
                      <div v-show="fuwuFrom.hashotel2 == 1">
                        <img src="../assets/img/fuyou2.png" alt />
                        <div>住宿</div>
                      </div>
                      <div v-show="fuwuFrom.hashotel2 != 1">
                        <img src="../assets/img/fuwu2.png" alt />
                        <div style="color: #c8c8c8">住宿</div>
                      </div>
                    </li>
                    <li>
                      <div v-show="fuwuFrom.hasshop2 == 1">
                        <img src="../assets/img/fuyou3.png" alt />
                        <div>商店</div>
                      </div>
                      <div v-show="fuwuFrom.hasshop2 != 1">
                        <img src="../assets/img/fuwu3.png" alt />
                        <div style="color: #c8c8c8">商店</div>
                      </div>
                    </li>
                    <li>
                      <div v-show="fuwuFrom.hasgasstation2 == 1">
                        <img src="../assets/img/fuyou4.png" alt />
                        <div>加油</div>
                      </div>
                      <div v-show="fuwuFrom.hasgasstation2 != 1">
                        <img src="../assets/img/fuwu4.png" alt />
                        <div style="color: #c8c8c8">加油</div>
                      </div>
                    </li>
                    <li>
                      <div v-show="fuwuFrom.hastoilet2 == 1">
                        <img src="../assets/img/fuyou5.png" alt />
                        <div>卫生间</div>
                      </div>
                      <div v-show="fuwuFrom.hastoilet2 != 1">
                        <img src="../assets/img/fuwu5.png" alt />
                        <div style="color: #c8c8c8">卫生间</div>
                      </div>
                    </li>
                    <li>
                      <div v-show="fuwuFrom.hasrepair2 == 1">
                        <img src="../assets/img/fuyou6.png" alt />
                        <div>汽修</div>
                      </div>
                      <div v-show="fuwuFrom.hasrepair2 != 1">
                        <img src="../assets/img/fuwu6.png" alt />
                        <div style="color: #c8c8c8">汽修</div>
                      </div>
                    </li>
                    <li>
                      <div v-show="fuwuFrom.hasparking2 == 1">
                        <img src="../assets/img/fuyou7.png" alt />
                        <div>停车</div>
                      </div>
                      <div v-show="fuwuFrom.hasparking2 != 1">
                        <img src="../assets/img/fuwu7.png" alt />
                        <div style="color: #c8c8c8">停车</div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </slot>
      </div>
    </cube-popup>
    <!-- 气象详情弹出层 -->
    <cube-popup type="my-popup" :zIndex="12" position="bottom" :mask-closable="true" ref="qixiangPopup"
      @mask-click="qixiangHide">
      <div class="cube-extend-popup-content" style>
        <slot>
          <div class="qixiangCon">
            <div class="qixiangTitle">
              <div style="width: 0.38rem; height: 0.38rem">
                <img src="../assets/img/qiIcon.png" alt style="width: 0.18rem; height: 0.18rem" />
              </div>
              <div class="stationName">{{ qixiangFrom.location }}</div>
            </div>
            <div class="qixiangMain">
              <div class="temNum">{{ qixiangFrom.temperature }}°</div>
              <div class="mianDe">
                <div>
                  <span>空气质量/PM2.5</span>
                  <span v-show="qixiangFrom.aqi > 0 && qixiangFrom.aqi < 50"
                    style="background: #f6f6f6; color: #07cc94">{{
                      qixiangFrom.aqiLevel }}/{{ qixiangFrom.aqi }}</span>
                  <span v-show="qixiangFrom.aqi >= 50 && qixiangFrom.aqi < 100"
                    style="background: #f6f6f6; color: #199ef4">{{ qixiangFrom.aqiLevel }}/{{ qixiangFrom.aqi }}</span>
                  <span v-show="qixiangFrom.aqi >= 100 && qixiangFrom.aqi < 150"
                    style="background: #f6f6f6; color: #fa8c16">{{ qixiangFrom.aqiLevel }}/{{ qixiangFrom.aqi }}</span>
                  <span v-show="qixiangFrom.aqi >= 150 && qixiangFrom.aqi < 200"
                    style="background: #f6f6f6; color: #fa541c">{{ qixiangFrom.aqiLevel }}/{{ qixiangFrom.aqi }}</span>
                  <span v-show="qixiangFrom.aqi >= 200" style="background: #f6f6f6; color: #f5222d">{{
                    qixiangFrom.aqiLevel
                  }}/{{ qixiangFrom.aqi }}</span>
                </div>
                <div class="windCon">{{ qixiangFrom.wind }}</div>
                <div class="mianCon">{{ qixiangFrom.forecast }}</div>
              </div>
              <div class="temIcon">
                <img :src="qixiangFrom.skycon" alt style="width: 0.48rem; height: 0.48rem" />
              </div>
            </div>
            <div style="width: 100%; height: 1.1rem" ref="myChart"></div>
          </div>
        </slot>
      </div>
    </cube-popup>
    <!-- 附近弹出层 -->
    <cube-popup type="my-popup" :zIndex="11" position="bottom" :mask-closable="true" ref="fujinPopup"
      @mask-click="fujinHide">
      <div style>
        <slot>
          <div class="fuJinCon">
            <cube-tab-bar v-model="fujinIndex" :data="fujinTabs" :showSlider="true" setSliderTransform=".48rem">
            </cube-tab-bar>
            <div class="tabCon">
              <cube-scroll ref="scroll1" :data="staTabList" direction="horizontal"
                class="horizontal-scroll-list-wrap staList" v-if="fujinIndex == 1" key="scroll1">
                <ul>
                  <li v-for="(item, index) in staTabList" :key="index" @click="fuToStation(item)">
                    <div>
                      <img :src="item.picurl" alt style="
                          width: 0.5rem;
                          height: 0.5rem;
                          margin-right: 0.1rem;
                        " />
                    </div>
                    <div style="width: 60%">
                      <div style="font-weight: bolder">{{ item.name }}</div>
                      <div style="font-size: 0.12rem; margin-top: 0.14rem">
                        <span v-show="item.stationstatus == '正常'" style="
                            background: #eefdf2;
                            color: #28a652;
                            padding: 0 0.06rem;
                          ">{{ item.stationstatus }}</span>
                        <span v-show="item.stationstatus != '正常'" style="
                            background: #efeeee;
                            color: #999999;
                            padding: 0 0.06rem;
                          ">{{ item.stationstatus }}</span>
                      </div>
                    </div>
                    <div style>
                      <img src="../assets/img/dingwei.png" alt style="width: 0.1rem; height: 0.12rem" />
                      <span style="font-size: 0.12rem">{{
                        Number(item.distance)
                          ? (Number(item.distance) / 1000).toFixed(2)
                          : 0
                      }}km</span>
                    </div>
                  </li>
                </ul>
              </cube-scroll>
              <cube-scroll ref="scroll2" :data="fuwuTabList" direction="horizontal"
                class="horizontal-scroll-list-wrap staList" v-if="fujinIndex == 2">
                <ul>
                  <li v-for="(item, index) in fuwuTabList" :key="index" @click="fuToFuwu(item)">
                    <div>
                      <img :src="item.pic" alt style="
                          width: 0.7rem;
                          height: 0.5rem;
                          margin-right: 0.1rem;
                        " />
                    </div>
                    <div style="width: 60%">
                      <div style="font-weight: bolder">{{ item.name }}</div>
                      <div style="font-size: 0.12rem; margin-top: 0.14rem">
                        <span v-show="item.servicestatus == '1021001'" style="
                            background: #01874f;
                            color: #ffffff;
                            padding: 0 0.06rem;
                          ">正常</span>
                        <span v-show="item.servicestatus != '1021001'" style="
                            background: #efeeee;
                            color: #999999;
                            padding: 0 0.06rem;
                          ">关闭</span>
                      </div>
                    </div>
                    <div style>
                      <img src="../assets/img/dingwei.png" alt style="width: 0.1rem; height: 0.12rem" />
                      <span style="font-size: 0.12rem">{{
                        Number(item.distance)
                          ? (Number(item.distance) / 1000).toFixed(2)
                          : 0
                      }}km</span>
                    </div>
                  </li>
                </ul>
              </cube-scroll>
              <cube-scroll ref="scroll3" :data="jiayTabList" direction="horizontal"
                class="horizontal-scroll-list-wrap staList" v-if="fujinIndex == 3" key="scroll3">
                <ul>
                  <li v-for="(item, index) in jiayTabList" :key="index" style="display: block">
                    <div>
                      <div style="font-size: 0.14rem; font-weight: bolder">
                        {{ item.oilstationname }}
                        <img src="../assets/img/24hours.png" alt v-show="item.opentime == '24小时'" style="
                            width: 0.17rem;
                            height: 0.17rem;
                            vertical-align: middle;
                            margin-left: 0.05rem;
                          " />
                        <img src="../assets/img/closes.png" alt v-show="item.opentime != '24小时'" style="
                            width: 0.17rem;
                            height: 0.17rem;
                            vertical-align: middle;
                            margin-left: 0.05rem;
                          " />
                      </div>
                    </div>
                    <div style="
                        display: flex;
                        margin-top: 0.14rem;
                        justify-content: space-between;
                      ">
                      <div style="font-size: 0.12rem; color: #d60103">
                        ￥{{ item.price }}
                      </div>
                      <div>
                        <img src="../assets/img/dingwei.png" alt style="
                            width: 0.1rem;
                            height: 0.12rem;
                            vertical-align: middle;
                          " />
                        <span style="font-size: 0.12rem">{{
                          Number(item.distance)
                            ? (Number(item.distance) / 1000).toFixed(2)
                            : 0
                        }}km</span>
                      </div>
                    </div>
                  </li>
                </ul>
              </cube-scroll>
            </div>
          </div>
        </slot>
      </div>
    </cube-popup>
  </div>
</template>

<script>
import remoteScript from "../utils/remoteScript.js";
import svgPanZoom from "svg-pan-zoom";
import "../assets/js/hammer.min.js";
import selectBox from "@/components/selectBox";
import echarts from "echarts";
import wx from "weixin-js-sdk";
import saveSvgAsPng from 'save-svg-as-png'
import { ImagePreview } from 'vant';
import 'vant/lib/image-preview/style';
import tollStationDetail from './components/tollStationDetail';
import tollStationDetail1 from './components/tollStationDetail1';
import { transform } from "babel-core";
export default {
  components: {
    selectBox, tollStationDetail, tollStationDetail1
  },
  data() {
    return {
      sessionUserInfo: "",
      browser: this.$route.params.browser,
      initFlag: false,
      paper: "",
      eventsHandler: "",
      tstype: true,
      wlyctype: true, //网络延迟提示判断
      timer: null,
      longitude: "",
      latitude: "",
      address: "",
      qiTipFlag: false,
      // 路况弹窗
      lkFlag: false,
      // 阻塞显示
      zuFlag: true,
      // 事故显示
      shiguFlag: true,
      // 管制显示
      guanFlag: true,
      // 检疫显示
      jianyiFlag: true,
      // 正在施工显示
      gongingFlag: false,
      // 施工计划显示
      gongjiFlag: false,
      // 收费站正常显示
      feizhengFlag: false,
      // // 收费站封闭显示
      // feifengFlag: true,
      // 收费站单向封闭显示
      unidirectionFlag: true,
      // 收费站双向封闭显示
      bidirectionFlag: true,
      // 收费站管制
      feiguanFlag: true,
      // 美食显示
      meiFlag: false,
      // 景区显示
      jingFlag: false,
      // 服务区显示
      fuwuFlag: false,
      // 气象
      qixiangFlag: false,
      // 图标大小
      iconHeight: 14,
      iconWidth: 14,
      // 图标偏移
      iconPx: 7,
      iconPy: 14,
      // 事件详情
      sjDetialFrom: {},
      // 收费站详情
      stationDeFrom: {},
      stationDeFromStatus: {},
      nearStaList: [],
      // 服务区详情
      fuwuFrom: {},
      staDetialFlag: false,
      // 气象详情
      qixiangFrom: {},
      // 附近
      fujinIndex: 1,
      fujinTabs: [
        {
          label: "收费站",
          value: 1
        },
        {
          label: "服务区",
          value: 2
        },
        {
          label: "加油站",
          value: 3
        }
      ],
      staTabList: [],
      fuwuTabList: [],
      jiayTabList: []
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      localStorage.removeItem("mylatitude");
      localStorage.removeItem("mylongitude");
      localStorage.removeItem("myAddress");
    });
  },
  mounted() {
    // console.log("Snap");
    // console.log(Snap);
    localStorage.removeItem("mylatitude");
    localStorage.removeItem("mylongitude");
    localStorage.removeItem("myAddress");
    if (localStorage.getItem("qiTipFlag")) {
      this.qiTipFlag = false;
    } else {
      this.qiTipFlag = true;
    }
    // if (this.$route.query.comeRoute) {
    //   localStorage.setItem(
    //     "comeRouteObj",
    //     JSON.stringify({
    //       comeRoute: this.$route.query.comeRoute,
    //       channelid: this.$route.query.channelid
    //     })
    //   );
    // }
    // if (window.history && window.history.pushState) {
    //   // 往历史记录里面添加一条新的当前页面的url
    //   history.pushState(null, null, document.URL);
    //   // 给 popstate 绑定一个方法 监听页面刷新
    //   window.addEventListener("popstate", this.backChange, false); //false阻止默认事件
    // }
    this.getNowCity();
    this.getSVGInit();
    // window.uroadplus_web_setInfo = this.uroadplus_web_setInfo;
    // this.getUserInfo();
  },
  destroyed() {
    // window.removeEventListener("popstate", this.backChange, false);
  },
  methods: {
    exportPng() {
      let loadingToast = this.$createToast({
        txt: "生成图片中...",
        mask: true
      }).show();
      let el = document.getElementById('svg2');
      saveSvgAsPng.svgAsPngUri(el, { scale: 2.5, backgroundColor: '#FFF' }).then((re) => {
        ImagePreview({ images: [re], closeable: true, maxZoom: 14 });
        this.$nextTick(() => {
          loadingToast.hide();
        })
      });
    },
    // backChange() {
    //   console.log('localStorage.getItem("comeRouteObj")----------');
    //   console.log(localStorage.getItem("comeRouteObj"));
    //   if (localStorage.getItem("comeRouteObj")) {
    //     let comeRouteObj = JSON.parse(localStorage.getItem("comeRouteObj"));
    //     let url = `https://app.ln-gst.com/${comeRouteObj.comeRoute}/#/?channelid=${comeRouteObj.channelid}`;
    //     localStorage.removeItem("comeRouteObj");
    //     window.location.replace(url);
    //   } else if (this.$route.params.browser.versions.weixin) {
    //     wx.closeWindow();
    //   } else if (this.$route.params.browser.versions.android) {
    //     window.liaoningactivity.customServiceBack();
    //   } else if (this.$route.params.browser.versions.ios) {
    //     window.customServiceBack();
    //   } else {
    //     history.back();
    //   }
    // },
    noFun() {
      this.$alertShow("暂未开通~~");
    },
    GetQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    // getUserInfo() {
    //   if (this.browser.versions.weixin) {
    //     this.sessionUserInfo = JSON.parse(
    //       localStorage.getItem("sessionUserInfo")
    //     );
    //     if (!this.sessionUserInfo) {
    //       let code = this.GetQueryString("code");
    //       if (!code) {
    //         //判断来源
    //         window.location.href =
    //           "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx719a9cc8be419470&redirect_uri=https://app.ln-gst.com/sessionSVGVue/index.html&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect";
    //       } else {
    //         let loadingToast = this.$createToast({
    //           txt: "正在登陆",
    //           mask: true,
    //         }).show();
    //         this.$Post(
    //           "highwayInfoSVGWeb/getopenid",
    //           { code: code },
    //           ({ data }) => {
    //             console.log("sessionUserInfo");
    //             console.log(data);
    //             this.sessionUserInfo = data.userinfo;
    //             localStorage.setItem(
    //               "sessionUserInfo",
    //               JSON.stringify(data.userinfo)
    //             );
    //             loadingToast.hide();
    //           },
    //           (err) => {
    //             loadingToast.hide();
    //             this.$alertShow(err.msg);
    //           },
    //           true
    //         );
    //       }
    //     }
    //   } else if (this.browser.versions.ios) {
    //     if (
    //       !this.sessionUserInfo ||
    //       (this.sessionUserInfo && !this.sessionUserInfo.unionid)
    //     ) {
    //       window.uroadplus_login();
    //     }
    //   } else if (this.browser.versions.android) {
    //     if (
    //       !this.sessionUserInfo ||
    //       (this.sessionUserInfo && !this.sessionUserInfo.unionid)
    //     ) {
    //       window.uroadhtml.uroadplus_login();
    //     }
    //   }
    // },
    // //ios调用的方法
    // uroadplus_web_setInfo(openid, nickname, phone, icon) {
    //   //判断是否已经有用户信息
    //   this.sessionUserInfo = {
    //     unionid: openid,
    //     phone: phone,
    //   };
    //   // localStorage.setItem(
    //   //   "sessionUserInfo",
    //   //   JSON.stringify(this.sessionUserInfo)
    //   // );
    // },
    // 获取定位
    getNowCity() {
      const _this = this;
      // AMap.Geolocation
      let loadingToast = this.$createToast({
        txt: "定位中...",
        mask: true
      }).show();
      AMap.plugin("AMap.Geolocation", () => {
        let Geolocation = new AMap.Geolocation({
          timeout: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) ? 3000 : 60000,
          enableHighAccuracy: true //是否使用高精度定位，默认:true
        });
        Geolocation.getCurrentPosition((status, res) => {
          console.log("定位");
          console.log(status);
          console.log(res);
          if (status === "complete" && res.info === "SUCCESS") {
            this.longitude = res.position.lng;
            this.latitude = res.position.lat;
            this.address = res.formattedAddress;
          } else {
            this.$alertShow("定位失败，请进入【设置】>【隐私】>【定位服务】/【权限管理】中确认是否打开开关，并允许辽宁高速通使用定位服务。如已打开定位服务，请检查您的网络。", '我知道了');
          }
          loadingToast.hide();
        });
      });
    },
    // 简图
    getSVGInit() {
      let that = this;
      Snap.load(null, function (f) {
        var g = Snap("#svgc");
        var svg = f.select("svg");
        g.g().add(svg);
        that.paper = g;
        console.log('paper', that.paper);
        document.querySelector("#layer3").onclick = that.qixiangFun;
        // document.querySelector("#layer1").onclick = that.qixiangFun;
        // document.querySelector("#layer5").onclick = that.qixiangFun;
        //手机缩放
        let zuoDistance = 0;
        let shangDistance = 0;
        let youDistance = 0;
        let xiaDistance = 0;

        that.eventsHandler = {
          haltEventListeners: [
            "touchstart",
            "touchend",
            "touchmove",
            "touchleave",
            "touchcancel"
          ],
          init: function (options) {
            var instance = options.instance,
              initialScale = 1,
              pannedX = 0,
              pannedY = 0;
            // Init Hammer
            // Listen only for pointer and touch events
            this.hammer = Hammer(options.svgElement, {
              inputClass: Hammer.SUPPORT_POINTER_EVENTS
                ? Hammer.PointerEventInput
                : Hammer.TouchInput
            });

            // Enable pinch
            this.hammer.get("pinch").set({ enable: true });

            // Handle double tap
            this.hammer.on("doubletap", function (ev) {
              instance.zoomIn();
            });

            // Handle pan
            this.hammer.on("panstart panmove", function (ev) {
              if (ev.type === "panstart") {
                pannedX = 0;
                pannedY = 0;
              }
              // console.log(ev)
              // console.log(ev.deltaX - pannedX)
              // console.log(ev.deltaY - pannedY)
              // Pan only the difference
              instance.panBy({
                x: ev.deltaX - pannedX,
                y: ev.deltaY - pannedY
              });
              pannedX = ev.deltaX;
              pannedY = ev.deltaY;
            });

            // Handle pan
            this.hammer.on("panend", function (ev) {
              console.log("svgcsvgcsvgcsvgcsvgc");
              console.log(ev);
              console.log(ev.distance);
              // let x= options.instance.getPan().x
              // let y= options.instance.getPan().y
              let svgElement = options.svgElement;
              let a = svgElement.children[1].transform.animVal[0].matrix.a;
              let screenW = a * svgElement.clientWidth;
              let screenH = a * svgElement.clientHeight;
              // let moveX =
              //   svgElement.children[1].transform.animVal[0].matrix.e;
              // let moveY =
              //   svgElement.children[1].transform.animVal[0].matrix.f;
              console.log(zuoDistance);
              console.log(shangDistance);
              // console.log(screenW / 2)
              // console.log(zuoDistance)
              // // 左
              // if (ev.direction == 2) {
              //   zuoDistance += ev.distance;
              //   youDistance -= ev.distance;
              //   if (zuoDistance > (screenW / 2)-100) {
              //     options.instance.panBy({ x: -ev.deltaX, y: 0 });
              //   }
              // }
              // // 上
              // if (ev.direction == 8) {
              //   shangDistance += ev.distance;
              //   xiaDistance -= ev.distance;
              //   if (shangDistance > (screenH / 2)-100) {
              //     options.instance.panBy({ x: 0, y: -ev.deltaY });
              //   }
              // }
              // // 右
              // if (ev.direction == 4) {
              //   youDistance += ev.distance;
              //   zuoDistance -= ev.distance;
              //   if (youDistance > (screenW / 2)-100) {
              //     options.instance.panBy({ x: -ev.deltaX, y: 0 });
              //   }
              // }
              // // 下
              // if (ev.direction == 16) {
              //   xiaDistance += ev.distance;
              //   shangDistance -= ev.distance;
              //   if (xiaDistance > (screenH / 2)-100) {
              //     options.instance.panBy({ x: 0, y: -ev.deltaY });
              //   }
              // }
              // console.dir(options.instance.getPan());
            }); // Handle pinch
            this.hammer.on("pinchstart pinchmove", function (ev) {
              // On pinch start remember initial zoom
              if (ev.type === "pinchstart") {
                initialScale = instance.getZoom();
                instance.zoom(initialScale * ev.scale);
              }

              instance.zoom(initialScale * ev.scale);
            });
            // Prevent moving the page on some devices when panning over SVG
            options.svgElement.addEventListener("touchmove", function (ev) {
              ev.preventDefault();
            });
          },
          destroy: function () {
            this.hammer.destroy();
          }
        };
        panZoom = window.panZoom = svgPanZoom("#svgc", {
          viewportSelector: ".svg-pan-zoom_viewport",
          panEnabled: true,
          zoomEnabled: true,
          dblClickZoomEnabled: true,
          mouseWheelZoomEnabled: true,
          preventMouseEventsDefault: true,
          zoomScaleSensitivity: 0.3,
          minZoom: 0.5,
          maxZoom: 100,
          fit: true,
          center: true,
          refreshRate: "auto",
          customEventsHandler: that.eventsHandler,
          onZoom: function () {
            // layer.load(20);
            return; // resMapOld
            //放大后的数值
            var newzoom = panZoom.getZoom();
            var newpan = panZoom.getPan();
          }
        });

        panZoom.reset();
        panZoom.zoom(1);
        panZoom.panBy({ x: 0, y: 0 });
        that.initFlag = true;
        that.refreshEvent(); //去除原先的事件等图层
        that.getAllThings();
      });
    },

    refreshEvent() {
      this.tstype = true;
      this.wlyctype = true;
      this.removeEventBySvg();
    },
    removeEventBySvg() {
      if (!!this.paper.select("#event_g")) {
        this.paper.select("#event_g").remove();
      }
      if (!!this.paper.select("#event_sg")) {
        this.paper.select("#event_sg").remove();
      }
      if (!!this.paper.select("#event_gz")) {
        this.paper.select("#event_gz").remove();
      }

      //2018-9-13  chenping-change
      if (!!this.paper.select("#event_pv")) {
        this.paper.select("#event_pv").remove();
      }
      //end

      if (!!this.paper.select("#cctv_g")) {
        this.paper.select("#cctv_g").remove();
      }
    },
    reloadF() {
      this.getAllThings();
    },
    luFun() {
      if (this.qixiangFlag) {
        this.changQiX();
      }
      this.lkFlag = true;
      if (this.$route.params.browser.versions.weixin) {
        return;
      } else if (
        window.roadBaiduClick &&
        this.$route.params.browser.versions.ios
      ) {
        window.roadBaiduClick("20");
      } else if (
        window.liaoningactivity &&
        window.liaoningactivity.roadBaiduClick &&
        this.$route.params.browser.versions.android
      ) {
        window.liaoningactivity.roadBaiduClick("20");
      }
      console.log(222);
    },
    // 重新获取定位
    reLoadEven() {
      let that = this;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(

          function (position) {
            that.longitude = position.coords.longitude;
            that.latitude = position.coords.latitude;
          },
          function (e) {
            var msg = e.code;
            var dd = e.message;
          }
        );
      }
    },
    //放大SVG
    enlargeSVG() {
      panZoom.zoomIn();
    },
    //缩小SVG
    narrowSVG() {
      panZoom.zoomOut();
    },
    // 我知道啦
    iKnow() {
      this.qiTipFlag = false;
      localStorage.setItem("qiTipFlag", true);
    },
    // 获取事件数据
    getAllThings() {
      const promises = [];
      // 阻塞显示
      if (this.zuFlag && !this.qixiangFlag) {
        promises.push(this.getThings(1006302));
      }
      // 事故显示
      if (this.shiguFlag && !this.qixiangFlag) {
        promises.push(this.getThings(1006301));
      }
      // 管制显示
      if (this.guanFlag && !this.qixiangFlag) {
        promises.push(this.getThings(1006303));
      }
      // 检疫显示
      if (this.jianyiFlag && !this.qixiangFlag) {
        promises.push(this.getThings(1006106));
      }
      // 正在施工显示
      if (this.gongingFlag && !this.qixiangFlag) {
        promises.push(this.getThings(1006002));
      }
      // 施工计划显示
      if (this.gongjiFlag && !this.qixiangFlag) {
        promises.push(this.getThings(1006003));
      }
      // 服务区显示
      if (this.fuwuFlag && !this.qixiangFlag) {
        promises.push(this.getFuwuquList());
      }
      // 收费站正常显示
      if (this.feizhengFlag && !this.qixiangFlag) {
        promises.push(this.getStation("正常"));
      }
      // 收费站封闭显示
      // if (this.feifengFlag && !this.qixiangFlag) {
      //   promises.push(this.getStation("封闭"));
      // }
      // 收费站单向封闭显示
      if (this.unidirectionFlag && !this.qixiangFlag) {
        promises.push(this.getStation("单向封闭"));
      }
      // 收费站双向封闭显示
      if (this.bidirectionFlag && !this.qixiangFlag) {
        promises.push(this.getStation("双向封闭"));
      }
      // 收费站管制
      if (this.feiguanFlag && !this.qixiangFlag) {
        promises.push(this.getStation("管制"));
      }

      let loadingToast = this.$createToast({
        txt: "加载中...",
        mask: true
      }).show();
      Promise.all(promises)
        .then(values => {
          console.log("初始筛选数据");
          try {
            for (const item of values) {
              console.log(item);
              if (!!item.err) {
                continue;
              }
              if (
                [1006302, 1006301, 1006303, 1006106, 1006002, 1006003].indexOf(
                  item.type
                ) > -1
              ) {
                this.handleThings(item.data, item.type);
              } else if (
                ["正常", "单向封闭", "双向封闭", "管制"].indexOf(item.type) > -1
              ) {
                this.handleStation(item.data, item.type);
              } else if (item.type == "fuwuqu") {
                this.handleFuwuqu(item.data);
              }
            }
          } catch (e) {
            console.log("catch", e);
          }

          loadingToast.hide();
        })
        .catch(err => {
          loadingToast.hide();
          console.log("err", "getAllThings获取事件数据", err);
          // this.$alertShow(err.msg);
        });
    },
    // 获取事件
    getThings(eventtype) {
      return new Promise((resolve, reject) => {
        this.$Post(
          "highwayInfoSVGWeb/getEventDataByType2",
          { eventtype: eventtype },
          ({ data, status, msg }) => {
            if (status == "00") {
              resolve({
                type: eventtype,
                data
              });
            } else {
              resolve({
                type: eventtype,
                err: { msg }
              });
            }
          },
          err => {
            resolve({
              type: eventtype,
              err
            });
          }
        );
      });
    },
    // 处理事件
    handleThings(data, eventtype) {
      // console.log('handleThings', data);
      if (data.length) {
        let eventimg;
        if (eventtype == "1006302") {
          eventimg = "zuse";
        } else if (eventtype == "1006301") {
          eventimg = "shigu";
        } else if (eventtype == "1006303") {
          eventimg = "guanzhi";
        } else if (eventtype == "1006002") {
          eventimg = "shigong";
        } else if (eventtype == "1006003") {
          eventimg = "shiji";
        } else if (eventtype == "1006106") {
          eventimg = "guanzhijianyi";
        }
        data.forEach(item => {
          this.shiguIcon(item, eventimg, eventtype);
        });
      }
    },
    // 事件图标
    shiguIcon(item, eventimg, strtype) {

      // try {
      if (!item.trafficsplitcode) return;
      if (item.trafficsplitcode.indexOf("s") == -1) {
        let pathLo = this.paper.select(`#f${item.trafficsplitcode}`);
        if (pathLo) {
          let tuLength = pathLo.getTotalLength();
          let scale = tuLength / item.trueLength;
          if (item.flag == "1") {
            // 图标显示
            let iconObj = pathLo.getPointAtLength(
              item.getPointAtLength * scale
            );

            if (!iconObj.x) console.log('iconObj', item.getPointAtLength, tuLength, item.trueLength, item.getPointAtLength * scale);

            let tx = pathLo.transform().global && pathLo.transform().global.split(',').length ? parseFloat(pathLo.transform().global.split(',')[0].replace('t', '')) : 0;
            let ty = pathLo.transform().global && pathLo.transform().global.split(',').length ? parseFloat(pathLo.transform().global.split(',')[1].replace('t', '')) : 0;

            var imgObj = this.getEvenIcon(iconObj.x + tx, iconObj.y + ty, eventimg);
            if (!this.paper.select("#event_mix_" + strtype)) {
              let tmp = Snap.parse(`<g id= 'event_mix${strtype}'></g>`);
              this.paper
                .select("#layer2")
                .parent()
                .add(tmp);
            }
            var img = this.paper.select("#event_mix" + strtype).g();
            img.add(imgObj);
            img.attr({ x: iconObj.x });
            img.attr({ y: iconObj.y });
            img.attr({ cursor: "pointer" });
            img.attr({ class: strtype });
            img.click(() => {
              this.sgdjck(item, "sj", eventimg);
            });
          }
          // 路段变色
          let color = "";
          if (item.status == "1008002") {
            color = "#ffff00";
          } else if (item.status == "1008003") {
            color = "#ff0000";
          } else if (item.status == "1008004" || item.status == "1008005") {
            color = "#cccccc";
          }
          let arr = item.strokeStr.split(",");
          let scalearr = arr.map(itemPoit => {
            return itemPoit * scale;
          });
          pathLo.clone().attr({
            stroke: color,
            "stroke-dasharray": scalearr
          });
        }
      } else {
        let pathLo = null;
        try {
          pathLo =
            item.isdouble == 1
              ? this.paper.select(`#${item.trafficsplitcode}`).parent()
              : this.paper.select(`#${item.trafficsplitcode}`);
          // console.log('正常的',item);
        } catch (e) {
          console.log('没有parent的那个是 ', item, item.trafficsplitcode);
        }
        // let pathLo =
        //   item.isdouble == 1
        //     ? this.paper.select(`#${item.trafficsplitcode}`).parent()
        //     : this.paper.select(`#${item.trafficsplitcode}`);
        // let pathLo = this.paper.select(`#s01166`);
        if (pathLo) {
          if (item.flag == "1") {
            let tx = pathLo.transform().global && pathLo.transform().global.split(',').length ? parseFloat(pathLo.transform().global.split(',')[0].replace('t', '')) : 0;
            let ty = pathLo.transform().global && pathLo.transform().global.split(',').length ? parseFloat(pathLo.transform().global.split(',')[1].replace('t', '')) : 0;
            var x = pathLo.getBBox().cx + tx;
            var y = pathLo.getBBox().cy + ty;
            var imgObj = this.getEvenIcon(x, y, eventimg);
            if (!this.paper.select("#event_mix_" + strtype)) {
              let tmp = Snap.parse(`<g id= 'event_mix${strtype}'></g>`);
              this.paper
                .select("#layer2")
                .parent()
                .add(tmp);
            }
            var img = this.paper.select("#event_mix" + strtype).g();

            img.add(imgObj);
            img.attr({ cursor: "pointer" });
            img.click(() => {
              this.sgdjck(item, "sj", eventimg);
            });
          }
        }
      }
      // } catch (e) {
      //   console.log("事件图标里面的");
      //   console.log(e);
      // }
    },
    // 获取收费站
    getStation(eventtype) {
      return new Promise(resolve => {
        this.$Post(
          "highwayInfoSVGWeb/getTollstationStatus",
          { eventtype: eventtype },
          ({ data, status, msg }) => {
            if (status == "00") {
              resolve({
                type: eventtype,
                data
              });
            } else {
              resolve({
                type: eventtype,
                err: { msg }
              });
            }
          },
          err => {
            resolve({
              type: eventtype,
              err
            });
          }
        );
      });
    },
    // 处理收费站
    handleStation(data, eventtype) {
      if (data.length) {
        data.forEach(item => {
          let eventimg;
          if (item.controlcode == "2007000") {
            eventimg = "shouzheng";
          } else if (item.controlcode == "2007001") {
            // eventimg = "churufeng";
            eventimg = "shuangxiangfengbi";
          } else if (item.controlcode == "2007002") {
            // eventimg = "churudan";
            eventimg = "danxiangfengbi";
          } else if (item.controlcode == "2007003") {
            // eventimg = "rufeng";
            eventimg = "danxiangfengbi";
          } else if (item.controlcode == "2007004") {
            // eventimg = "chufeng";
            eventimg = "danxiangfengbi";
          } else if (item.controlcode == "2007005") {
            // eventimg = "rudan";
            eventimg = "danxiangfengbi";
          } else if (item.controlcode == "2007006") {
            // eventimg = "chudan";
            eventimg = "danxiangfengbi";
          } else if (item.controlcode == "2007007") {
            eventimg = "xianzhi";
          }

          this.dealStationIcon(item, "station_" + eventtype, eventimg);
        });
      }
    },
    // 收费站图标
    dealStationIcon(data, evenbox, eventimg) {
      let ph = this.paper.select(`#${data.trafficsplitcode}`);

      // var ph = this.paper.select("#" + data.trafficsplitcode);
      // console.log("data.trafficsplitcode");
      // console.log(data.trafficsplitcode);
      if (ph) {
        let tx = ph.transform().global && ph.transform().global.split(',').length ? parseFloat(ph.transform().global.split(',')[0].replace('t', '')) : 0;
        let ty = ph.transform().global && ph.transform().global.split(',').length ? parseFloat(ph.transform().global.split(',')[1].replace('t', '')) : 0;
        var x = ph.getBBox().cx + tx;
        var y = ph.getBBox().cy + ty;

        var imgObj = this.getEvenIcon(x, y, eventimg);
        let img = "";
        if (this.paper.select(evenbox)) {
          this.paper.select(evenbox).remove();
        }
        let tmp = Snap.parse('<g id= "' + evenbox + '"></g>');
        this.paper
          .select("#layer2")
          .parent()
          .add(tmp);
        img = this.paper.select("#" + evenbox).g();
        img.add(imgObj);
        // img.attr({ "x": x });
        // img.attr({ "y": y });
        img.attr({ cursor: "pointer", id: data.trafficsplitcode });
        // img.attr({ "class": eventype });
        img.click(() => {
          this.sgdjck(data, "station", eventimg);
        });
      }
    },
    // 获取服务区
    getFuwuquList() {
      return new Promise(resolve => {
        this.$Post(
          "highwayInfoSVGWeb/fetchService",
          { longitude: this.longitude, latitude: this.latitude, limit: "" },
          ({ data, status, msg }) => {
            if (status == "00") {
              resolve({
                type: "fuwuqu",
                data
              });
            } else {
              resolve({
                type: "fuwuqu",
                err: { msg }
              });
            }
          },
          err => {
            resolve({
              type: "fuwuqu",
              err
            });
          }
        );
      });
    },
    // 处理服务区
    handleFuwuqu(data) {
      if (data.length) {
        data.forEach(item => {
          this.fuwuquIcon(item);
        });
      }
    },
    // 服务区图标
    fuwuquIcon(item) {
      let pathLo = this.paper.select(`#service${item.poiid}`) || this.paper.select(`#service${item.poiid}_x0A_`);
      if (pathLo) {
        let tx = pathLo.transform().global && pathLo.transform().global.split(',').length ? parseFloat(pathLo.transform().global.split(',')[0].replace('t', '')) : 0;
        let ty = pathLo.transform().global && pathLo.transform().global.split(',').length ? parseFloat(pathLo.transform().global.split(',')[1].replace('t', '')) : 0;
        var x = pathLo.getBBox().cx + tx;
        var y = pathLo.getBBox().cy + ty;
        let imgs = "";
        if (item.servicestatus == "1021001") {
          imgs = "fuzheng";
        } else {
          imgs = "fufeng";
        }
        var imgObj = this.getEvenIcon(x, y, imgs);
        if (!this.paper.select("#event_fu")) {
          let tmp = Snap.parse('<g id= "event_fu"><g id="temp_g2"></g></g>');
          this.paper
            .select("#layer2")
            .parent()
            .add(tmp);
        }
        var img = this.paper.select("#event_fu").g();
        img.add(imgObj);
        img.attr({ x: x });
        img.attr({ y: y });
        img.attr({ cursor: "pointer" });
        img.attr({ class: "fuzheng" });
        img.click(() => {
          this.sgdjck(item, "fuwu", imgs);
        });
      }
    },
    // 生产图标
    getEvenIcon(x, y, src) {
      let obj = null;
      let pos_x = x - this.iconPx;
      let pos_y = y - this.iconPy;
      let str = ` <image x="${pos_x}" y="${pos_y}" height="${this.iconHeight
        }px" width="${this.iconWidth
        }px" xlink:href=${require(`../assets/img/${src}.png`)}></image>`;
      obj = Snap.parse(str);
      return obj;
    },
    // 点亮城市
    lightCity(obj) {
      panZoom.reset();
      panZoom.zoom(Number(obj.zoom));
      panZoom.panBy({ x: Number(obj.panbyx), y: Number(obj.panbyy) });
      // panZoom.panBy({ x: Number("-350.9459762081524"), y: Number("100.0536766490106") });
      console.log(obj);
      let pathLo = this.paper.select(`#${obj.splitcode}`);
      if (pathLo) {

        let paths = pathLo.clone();
        if (this.paper.select("#temp_g2")) {
          this.paper.select("#temp_g2").remove();
        }
        paths.attr({ "stroke-width": "1" });
        // paths.removeAttr('fill')
        paths.attr({ fill: "rgba(25, 158, 244, 0.1)" });
        paths.attr({ stroke: "#5EC0FF" });
        let tmp = Snap.parse('<g id="temp_g2"></g>');
        this.paper.select("#layer4").add(tmp);
        // var img = this.paper.image(eventimg, x, y, 24, 28);
        let name = this.paper.text(
          paths.getBBox().cx - 40,
          paths.getBBox().cy - 20,
          obj.name
        );
        this.paper.select("#temp_g2").add(paths);
        this.paper.select("#temp_g2").add(name);
        name.attr({
          stroke: "#000",
          fill: "none",
          "stroke-width": ".5",
          "font-size": "25px"
        });
        this.lightRoad(obj);
      }
    },
    // 点亮道路
    lightRoad(obj) {
      panZoom.reset();
      panZoom.zoom(Number(obj.zoom));
      // panZoom.zoom(Number(1.5));
      panZoom.panBy({ x: Number(obj.panbyx), y: Number(obj.panbyy) });
      // panZoom.panBy({ x: -900, y: 300 });

      if (this.paper.select("#temp_g3")) {
        this.paper.select("#temp_g3").remove();
      }
      obj.trafficsplitcode.forEach(item => {
        let pathLo = this.paper.select(`#${item.trafficsplitcode}`);
        if (pathLo) {
          let tx = pathLo.transform().global && pathLo.transform().global.split(',').length ? +pathLo.transform().global.split(',')[0].replace('t', '') : 0;
          let ty = pathLo.transform().global && pathLo.transform().global.split(',').length ? +pathLo.transform().global.split(',')[1].replace('t', '') : 0;
          let paths = pathLo.clone();
          paths.attr({
            "stroke-width": "3.8",
            stroke: "#197134",
            id: item.trafficsplitcode,
            transform: `translate(${tx},${ty})`
          });
          let tmp = Snap.parse(`<g id="temp_g3" ></g>`);
          this.paper.select("#layer3").add(tmp);
          // var img = this.paper.image(eventimg, x, y, 24, 28);
          this.paper.select("#temp_g3").add(paths);
        } else {
          console.log(item.trafficsplitcode)
        }
      });
      // document.querySelector("#temp_g3").onclick = this.qixiangFun;
    },
    // 清除选择
    allClear() {
      if (this.paper.select("#temp_g3")) {
        this.paper.select("#temp_g3").remove();
      }
      if (this.paper.select("#temp_g2")) {
        this.paper.select("#temp_g2").remove();
      }
      panZoom.reset();
      panZoom.zoom(1);
      panZoom.panBy({ x: 0, y: 0 });
    },
    changQiX() {
      if (this.qixiangFlag) {
        this.qixiangFlag = false;
        this.getAllThings();
      } else {
        if (this.paper.select("#event_mix1006301")) {
          this.paper.select("#event_mix1006301").remove();
        }
        if (this.paper.select("#event_mix1006302")) {
          this.paper.select("#event_mix1006302").remove();
        }
        if (this.paper.select("#event_mix1006303")) {
          this.paper.select("#event_mix1006303").remove();
        }
        if (this.paper.select("#event_mix1006002")) {
          this.paper.select("#event_mix1006002").remove();
        }
        if (this.paper.select("#event_mix1006003")) {
          this.paper.select("#event_mix1006003").remove();
        }
        if (this.paper.select("#event_fu")) {
          this.paper.select("#event_fu").remove();
        }
        if (this.paper.select("#station_正常")) {
          this.paper.select("#station_正常").remove();
        }
        if (this.paper.select("#station_封闭")) {
          this.paper.select("#station_封闭").remove();
        }
        if (this.paper.select("#station_管制")) {
          this.paper.select("#station_管制").remove();
        }
        this.qixiangFlag = true;
      }
    },
    // 气象
    qixiangFun(event) {
      if (this.qixiangFlag) {
        let loadingToast = this.$createToast({
          txt: "加载中...",
          mask: true
        }).show();
        // 点击点的横纵坐标
        let clickPointX = event.clientX;
        let clickPointY = event.clientY;
        this.$Post(
          "highwayInfoSVGWeb/fetchTruePathid",
          {
            pathid: event.target.id
          },
          ({ data, status }) => {
            if (status == "00") {
              if (data) {
                this.qiXPot(
                  data.instationcode,
                  data.outstationcode,
                  clickPointX,
                  clickPointY,
                  event.target.id,
                  loadingToast,
                  true
                );
              } else {
                this.qiXPot(
                  "",
                  "",
                  clickPointX,
                  clickPointY,
                  event.target.id,
                  loadingToast
                );
              }
            }
          },
          err => {
            loadingToast.hide();
            this.$alertShow(err.msg);
          },
          true
        );
      }
    },
    tranNumber(value) {
      var texts = [];
      if (value == 0) {
        texts.push("无雨");
      } else if (value == 1) {
        texts.push("小雨");
      } else if (value == 2) {
        texts.push("中雨");
      } else if (value == 3) {
        texts.push("大雨");
      } else if (value == 4) {
        texts.push("暴雨");
      }
      return texts;
    },
    qiXPot(
      dian1,
      dian2,
      clickPointX,
      clickPointY,
      trafficsplitcode,
      loadingToast,
      flag
    ) {
      //       let loadingToast = this.$createToast({
      //   txt: "加载中...",
      //   mask: true
      // }).show();

      // 点击点距离桩点1的距离
      let str1 = "";
      // 点击点距离桩点2的距离
      let str2 = "";
      if (flag) {
        // 桩点的横纵坐标
        let zPointX1 = document
          .querySelector("#" + dian1)
          .getBoundingClientRect().left;
        let zPointY1 = document
          .querySelector("#" + dian1)
          .getBoundingClientRect().top;
        let zPointX2 = document
          .querySelector("#" + dian2)
          .getBoundingClientRect().left;
        let zPointY2 = document
          .querySelector("#" + dian2)
          .getBoundingClientRect().top;
        // 点击点距离桩点1的距离
        str1 = Math.sqrt(
          Math.pow(Math.abs(clickPointX - zPointX1), 2) +
          Math.pow(Math.abs(clickPointY - zPointY1), 2)
        );
        // 点击点距离桩点2的距离
        str2 = Math.sqrt(
          Math.pow(Math.abs(clickPointX - zPointX2), 2) +
          Math.pow(Math.abs(clickPointY - zPointY2), 2)
        );
      }
      this.$Post(
        "highwayInfoSVGWeb/fetchRainfall",
        {
          trafficsplitcode: trafficsplitcode,
          startLength: str1,
          endLength: str2
        },
        ({ data }) => {
          if (flag) {
            let pathLo = this.paper.select(`#${trafficsplitcode}`);
            let tuLength = pathLo.getTotalLength();
            let scale = str2 / (str1 + str2);
            let iconObj = pathLo.getPointAtLength(tuLength * scale);
            let imgs = "qiding";
            var imgObj = this.getEvenIcon(iconObj.x, iconObj.y, imgs);
            let tmp = Snap.parse(
              '<g id= "qixiang_icon"><g id="temp_g2"></g></g>'
            );
            this.paper
              .select("#layer2")
              .parent()
              .add(tmp);
            var img = this.paper.select("#qixiang_icon").g();
            img.add(imgObj);
          } else {
            let pathLo = this.paper.select(`#${trafficsplitcode}`);
            var x = pathLo.getBBox().cx;
            var y = pathLo.getBBox().cy;
            let imgs = "qiding";
            var imgObj = this.getEvenIcon(x, y, imgs);
            let tmp = Snap.parse(
              '<g id= "qixiang_icon"><g id="temp_g2"></g></g>'
            );
            this.paper
              .select("#layer2")
              .parent()
              .add(tmp);
            var img = this.paper.select("#qixiang_icon").g();
            img.add(imgObj);
          }
          this.qixiangFrom = data;
          this.$refs.qixiangPopup.show();
          let xData = data.rainFall.map(item => {
            return item.datetime;
          });
          let yData = data.rainFall.map(item => {
            return item.value;
          });

          // return;
          let color = "";
          if (this.qixiangFrom.aqi < 50) {
            color = "#07CC94";
          } else if (this.qixiangFrom.aqi < 100) {
            color = "#199EF4";
          } else if (this.qixiangFrom.aqi < 150) {
            color = "#FA8C16";
          } else if (this.qixiangFrom.aqi < 200) {
            color = "#FA541C";
          } else {
            color = "#F5222D";
          }
          this.$refs.myChart.style.width = window.innerWidth - 20 + "px";
          let myChart = echarts.init(this.$refs.myChart);
          let option = {
            tooltip: {
              trigger: "axis",
              formatter: params => {
                let str = "";
                if (params[0].data == 0) {
                  str = "无雨";
                } else if (params[0].data == 1) {
                  str = "小雨";
                } else if (params[0].data == 2) {
                  str = "中雨";
                } else if (params[0].data == 3) {
                  str = "大雨";
                } else {
                  str = "暴雨";
                }
                return params[0].axisValueLabel + "\n" + str;
              }
            },
            grid: {
              left: "4%",
              right: "3%",
              bottom: "3%",
              top: "5%",
              containLabel: true
            },
            xAxis: {
              axisTick: {
                // 坐标轴小标记
                show: false // 属性show控制显示与否，默认不显示
              },
              type: "category",
              data: xData
            },
            yAxis: [
              {
                type: "value",
                axisTick: {
                  // 坐标轴小标记
                  show: false // 属性show控制显示与否，默认不显示
                },
                axisLabel: {
                  // 坐标轴文本标签，详见axis.axisLabel
                  show: false
                },
                axisLine: {
                  // 坐标轴文本标签，详见axis.axisLabel
                  show: false
                },
                splitLine: {
                  // 分隔线
                  show: false // 默认显示，属性show控制显示与否
                },
                splitArea: {
                  // 分隔区域
                  show: false // 默认不显示，属性show控制显示与否
                }
              },
              {
                type: "value",
                splitNumber: 5,
                max: 5,
                axisLine: {
                  // 坐标轴线
                  show: true, // 默认显示，属性show控制显示与否
                  lineStyle: {
                    // 属性lineStyle控制线条样式
                    color: "#F7F4F4",
                    width: 2,
                    type: "solid"
                  }
                },
                axisTick: {
                  // 坐标轴小标记
                  show: false // 属性show控制显示与否，默认不显示
                },
                splitLine: {
                  // 分隔线
                  show: true, // 默认显示，属性show控制显示与否
                  lineStyle: {
                    // 属性lineStyle控制线条样式
                    color: "#F7F4F4",
                    width: 2,
                    type: "dash"
                  }
                },
                axisLabel: {
                  show: true,
                  color: "#3d3d3d",
                  formatter: v => {
                    return this.tranNumber(v);
                  }
                }
              }
            ],
            series: [
              {
                data: yData,
                symbolSize: 0,
                smooth: true,
                itemStyle: {
                  color: "#29BC57"
                },
                sampling: "average",
                areaStyle: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: "rgba(41, 187, 85, 0.25)"
                    }
                  ])
                },
                stack: "a",
                type: "line",
                yAxisIndex: 1
              }
            ]
          };
          myChart.setOption(option);
          window.onresize = () => {
            myChart.resize();
          };
          loadingToast.hide();
        },
        err => {
          loadingToast.hide();
          this.$alertShow(err.msg);
        },
        true
      );
    },
    qixiangHide() {
      this.paper.select("#qixiang_icon")
        ? this.paper.select("#qixiang_icon").remove()
        : "";
      this.$refs.qixiangPopup.hide();
    },
    thingChange(flag, thingNum, str) {
      if (flag) {
        if (document.querySelector("#event_mix" + thingNum)) {
          document.querySelector("#event_mix" + thingNum).style.display =
            "none";
        }
        this[str] = false;
      } else {
        if (document.querySelector("#event_mix" + thingNum)) {
          document.querySelector("#event_mix" + thingNum).style.display =
            "block";
          this[str] = true;
        } else {
          this.getThings(thingNum).then(({ data }) => {
            this.handleThings(data, thingNum);
            this[str] = true;
          });
        }
      }
    },
    stationChange(flag, thingNum, str) {
      if (flag) {
        if (document.querySelector("#station_" + thingNum)) {
          document.querySelector("#station_" + thingNum).style.display = "none";
        }
        this[str] = false;
      } else {
        if (document.querySelector("#station_" + thingNum)) {
          document.querySelector("#station_" + thingNum).style.display =
            "block";
          this[str] = true;
        } else {
          let loadingToast = this.$createToast({
            txt: "加载中...",
            mask: true
          }).show();
          this.getStation(thingNum)
            .then(({ data }) => {
              this.handleStation(data, thingNum);
              this[str] = true;
              loadingToast.hide();
            })
            .catch(err => {
              console.log(err);
              loadingToast.hide();
              this.$alertShow(err.msg);
            });
        }
      }
    },
    fuwuChange(flag, str) {
      if (flag) {
        if (document.querySelector("#event_fu")) {
          document.querySelector("#event_fu").style.display = "none";
        }
        this[str] = false;
      } else {
        if (document.querySelector("#event_fu")) {
          document.querySelector("#event_fu").style.display = "block";
          this[str] = true;
        } else {
          let loadingToast = this.$createToast({
            txt: "加载中...",
            mask: true
          }).show();
          this.getFuwuquList()
            .then(({ data }) => {
              this.handleFuwuqu(data);
              this[str] = true;
              loadingToast.hide();
            })
            .catch(err => {
              console.log(err);
              loadingToast.hide();
              this.$alertShow(err.msg);
            });
        }
      }
    },
    async getFuwuquData(oridata, type, eventimg) {
      let loadingToast = this.$createToast({
        txt: "加载中...",
        mask: true
      }).show();
      let params = new FormData();
      params.append('ticketid', sessionStorage.getItem('ticketid') || '');
      params.append('poiid', oridata.poiid);
      params.append('latitude', this.latitude || '41.79110000065365');
      params.append('longitude', this.longitude || '123.4539679097361');
      params.append('channelNumber', this.browser.versions.ios ? '10202' : '10203');
      this.$fwqhttp('post', '/serviceAreaList', params, ({ data, code, msg }) => {
        console.log(data, code, msg)
        if (code == 200) {

          // 将接口返回的数据转换为 showAlertFu 需要的格式
          const [from, to] = data.serviceArealist.sort((a, b) => a.serviceAreadDirectionState - b.serviceAreadDirectionState);
          const fuwuObj = {
            name: from.serviceAreaName,
            roadname: from.expresswayName,
            address: from.serviceAreadAddress,
            distance: from.distance * 1000,
            pic: from.serviceAreadImg || '',
            servicestatus: from.openStatus === "1" ? "1021001" : "0",
            hasfood: from.isHotel === "1" ? 1 : 0,
            hashotel: from.isInn === "1" ? 1 : 0,
            hasshop: from.isStore === "1" ? 1 : 0,
            hasgasstation: from.isGasStation === "1" ? 1 : 0,
            hastoilet: from.isToilet === "1" ? 1 : 0,
            hasrepair: from.isVehicleMaintenance === "1" ? 1 : 0,
            hasparking: from.isParking === "1" ? 1 : 0,
            // 下行方向
            hasfood2: to.isHotel === "1" ? 1 : 0,
            hashotel2: to.isInn === "1" ? 1 : 0,
            hasshop2: to.isStore === "1" ? 1 : 0,
            hasgasstation2: to.isGasStation === "1" ? 1 : 0,
            hastoilet2: to.isToilet === "1" ? 1 : 0,
            hasrepair2: to.isVehicleMaintenance === "1" ? 1 : 0,
            hasparking2: to.isParking === "1" ? 1 : 0,
            latitude: to.latitude,
            longitude: to.longitude,
            poiid: to.poiid,
            servicestatus2: to.openStatus === "1" ? "1021001" : "0"
          };
          this.showAlertFu(fuwuObj, loadingToast);
         type && this.scaleIcon(oridata, type, eventimg);
        } else {
          this.$alertShow(msg);
        }
      }, err => {
        console.log(err);
        this.$alertShow(err.msg);
      });
    },
    //点击查看详情
    async sgdjck(data, type, eventimg) {
      console.log(data);
      if (type == "sj") {
        let loadingToast = this.$createToast({
          txt: "加载中...",
          mask: true
        }).show();
        this.showAlertDetails(data, loadingToast);
        this.scaleIcon(data, type, eventimg);
      } else if (type == "fuwu") {

        this.getFuwuquData(data, type, eventimg);

      } else {
        // if (this.sessionUserInfo && this.sessionUserInfo.unionid) {
        let loadingToast = this.$createToast({
          txt: "加载中...",
          mask: true
        }).show();
        this.showAlertStation(data, loadingToast);
        this.scaleIcon(data, type, eventimg);
        // } else {
        //   this.$createDialog({
        //     type: "confirm",
        //     // icon: 'cubeic-alert',
        //     title: "提示",
        //     content: "您还没有登录，是否先去登录？",
        //     confirmBtn: {
        //       text: "确定",
        //       active: true,
        //       disabled: false,
        //       href: "javascript:;",
        //     },
        //     cancelBtn: {
        //       text: "取消",
        //       active: false,
        //       disabled: false,
        //       href: "javascript:;",
        //     },
        //     onConfirm: () => {
        //       if (this.browser.versions.ios) {
        //         window.uroadplus_login();
        //       } else if (this.browser.versions.android) {
        //         window.uroadhtml.uroadplus_login();
        //       }
        //     },
        //     onCancel: () => {},
        //   }).show();
        // }
      }
    },
    scaleIcon(data, type, eventimg) {
      let ph;
      if (type == "sj") {
        if (data.trafficsplitcode.indexOf("s") == -1) {
          ph = this.paper.select("#f" + data.trafficsplitcode);
        } else {
          ph = this.paper.select("#" + data.trafficsplitcode);
        }
      } else {
        ph = this.paper.select("#" + data.trafficsplitcode);
      }
      if (!ph) return;
      let tuLength = ph.getTotalLength();
      let scale = tuLength / data.trueLength;
      let iconObj = ph.getPointAtLength(data.getPointAtLength * scale);
      let tx = ph.transform().global && ph.transform().global.split(',').length ? parseFloat(ph.transform().global.split(',')[0].replace('t', '')) : 0;
      let ty = ph.transform().global && ph.transform().global.split(',').length ? parseFloat(ph.transform().global.split(',')[1].replace('t', '')) : 0;
      let x = iconObj.x - (this.iconWidth - 0.3) + tx;
      let y = iconObj.y - (this.iconHeight + 2) + ty;
      if (this.paper.select("#temp_g")) {
        this.paper.select("#temp_g").remove();
      }
      let tmp = Snap.parse('<g id="temp_g"></g>');
      this.paper
        .select("#layer2")
        .parent()
        .add(tmp);
      let img = this.paper.image(
        require(`../assets/img/${eventimg}.png`),
        x,
        y,
        this.iconWidth * 2 + "px",
        this.iconHeight * 2 + "px"
      );
      let name = this.paper.text(x, y, data.name);
      this.paper.select("#temp_g").add(img);
      this.paper.select("#temp_g").add(name);
    },
    showAlertDetails(obj, loadingToast) {
      this.$refs.sjPopup.show();
      this.sjDetialFrom = obj;
      loadingToast.hide();
      let myScroll;
      function loadedscr() {
        setTimeout(function () {
          myScroll = new IScroll("#myscroller_rapper", {
            mouseWheel: true,
            scrollY: true,
            scrollbars: true,
            freeScroll: true,
            click: true,
            tap: true
          });
        });
      }
      // 防止页面未加载完成，导致取不到高宽值
      window.addEventListener("load", loadedscr, false);
    },

    sjHide() {
      this.paper.select("#temp_g") ? this.paper.select("#temp_g").remove() : "";
      this.$refs.sjPopup.hide();
    },
    showAlertFu(obj, loadingToast) {
      this.fuwuFrom = obj;
      this.$refs.fuwuPopup.show();
      loadingToast.hide();
    },
    fuwuHide() {
      this.paper.select("#temp_g") ? this.paper.select("#temp_g").remove() : "";
      this.$refs.fuwuPopup.hide();
    },
    showAlertStation(obj, loadingToast) {
      this.$Post(
        "highwayInfoSVGWeb/fetchDetail",
        {
          longitude: this.longitude,
          latitude: this.latitude,
          poiid: obj.poiid,
          useruuid: ""
        },
        ({ data }) => {
          this.stationDeFrom = data[0];
          this.stationDeFrom.control = obj.control;
          this.$Post(
            "highwayInfoSVGWeb/fetchControlDetail",
            {
              poiid: obj.poiid
            },
            ({ data }) => {
              this.stationDeFromStatus = data;
              this.stationDeFromStatus.obj = obj;
              this.stationDeFrom = { ...this.stationDeFrom, ...data }
              console.log(obj);
              this.$refs.stationPopup.show();
              loadingToast.hide();
            },
            err => {
              loadingToast.hide();
              this.$alertShow(err.msg);
            },
            true
          );
        },
        err => {
          this.$alertShow(err.msg);
        },
        true
      );
    },
    toStaDetial(obj) {
      let loadingToast = this.$createToast({
        txt: "加载中...",
        mask: true
      }).show();
      this.$Post(
        "highwayInfoSVGWeb/fetchNearbyTollstation",
        {
          poiid: obj.poiid,
          longitude: obj.coor_x,
          latitude: obj.coor_y
        },
        ({ data }) => {
          // this.$refs.staDetialPopup.show();
          this.staDetialFlag = true;
          this.nearStaList = data;
          this.$nextTick(() => {
            this.$refs.stationCons.scrollIntoView();
          });
          loadingToast.hide();
        },
        err => {
          loadingToast.hide();
          this.$alertShow(err.msg);
        },
        true
      );
    },

    handler(method, params) {
      if (/android/i.test(navigator.userAgent)) {
        let android = window.liaoningactivity || window.uroadhtml
        try {
          params ? android[method](...Object.values(params)) : android[method]()
        } catch (e) {
          console.log('android调用失败：' + method + e)
          throw new Error('android调用失败：' + method + e)
        }
      } else if (/ios|mac|iphone|ipod|pad/i.test(navigator.userAgent)) {
        if (method == 'uroadplus_loginNew') method = 'uroadplus_login_ticket'
        params = params ? params : {}
        try {
          window.webkit.messageHandlers[method].postMessage(params)
        } catch (e) {
          console.log('ios调用失败：' + method + e)
          throw new Error('ios调用失败：' + method + e)
        }
      }
    },
    toKefu() {
      try {
        let kefuUserId
        if (window.localStorage.getItem("kefuUserId")) {
          kefuUserId = window.localStorage.getItem("kefuUserId")
        } else {
          kefuUserId = Number(
            Math.random()
              .toString()
              .substr(3, 3) + Date.now()
          ).toString(36)
          window.localStorage.setItem("kefuUserId", kefuUserId)
        }
        if (this.browser.versions.weixin) {
          window.location.href = `https://kfapp.lngsyygl.cn/?t=14315/#/?channelid=b381386283dedcfbe3e77d2f6cf69f6d`
        } else {
          if (this.browser.versions.ios) {
            window.uroadplus_servicecustom_login()
          } else if (this.browser.versions.android) {
            try {
              if (!sessionStorage.getItem('ticketid')) {
                this.handler('uroadplus_loginNew')
              } else {
                this.handler('toWebH5', { url: `https://kfapp.lngsyygl.cn/?t=14315/#/` })
              }
            } catch (e) {
              window.location.href = `https://kfapp.lngsyygl.cn/?t=14315/#/`
            }

          }
        }
      } catch (e) {
        window.location.href = `https://kfapp.lngsyygl.cn/?t=14315/#/`
      }
    },
    // toKefu() {
    //   window.location.href = `https://app.ln-gst.com/customerserh5/index.html#/`
    //   return
    //   console.log(232)
    //   //   if (this.$route.query.comeFrom == 1) {
    //   //         https://app.ln-gst.com/customerserh5Publish/v51Green/#/
    //   // https://app.ln-gst.com/customerserh5Publish/v51Blue/#/

    //   if (this.browser.versions.ios) {
    //     // window.toWebH5(
    //     //   `https://app.ln-gst.com/yyfUserInterfaceH5/#/index/b381386283dedcfbe3e77d2f6cf69f6d/`
    //     // );
    //     window.toWebH5(
    //       `https://app.ln-gst.com/customerserh5Publish/v52Blue/#/`
    //     );
    //     // window.toWebH5(`https://app.ln-gst.com/customerserh5test/#/`);
    //   } else if (this.browser.versions.android) {
    //     // window.uroadhtml.toWebH5(
    //     //   `https://app.ln-gst.com/yyfUserInterfaceH5/#/index/b381386283dedcfbe3e77d2f6cf69f6d/`
    //     // );
    //     window.uroadhtml.toWebH5(
    //       `https://app.ln-gst.com/customerserh5Publish/v52Blue/#/`
    //     );
    //     // window.uroadhtml.toWebH5(
    //     //   `https://app.ln-gst.com/customerserh5test/#/`
    //     // );
    //   }
    //   // } else {
    //   //   window.location.href = `https://app.ln-gst.com/yyfUserInterfaceH5/#/index/b381386283dedcfbe3e77d2f6cf69f6d/`;
    //   window.location.href = `https://app.ln-gst.com/customerserh5Publish/v52Blue/#/`;
    //   // window.location.href = `https://app.ln-gst.com/customerserh5test/#/`;
    //   //}
    // },
    toDao1(obj) {
      this.$refs.tollStationDetail.daohang(obj.name, obj.coor_x, obj.coor_y)
    },
    toDao(obj) {
      if (this.browser.versions.weixin) {
        var gaodeLoc = [obj.coor_x, obj.coor_y];
        var marker = new AMap.Marker({
          position: gaodeLoc
        });
        marker.markOnAMAP({
          position: marker.getPosition(),
          name: obj.name
        });
      } else if (this.browser.versions.ios) {
        window.Duan(obj.name, obj.coor_x, obj.coor_y);
      } else if (this.browser.versions.android) {
        window.liaoningactivity.Duan(obj.name, obj.coor_x, obj.coor_y);
        // var gaodeLoc = [obj.coor_x, obj.coor_y];
        // var marker = new AMap.Marker({
        //   position: gaodeLoc,
        // });
        // marker.markOnAMAP({
        //   position: marker.getPosition(),
        //   name: obj.name,
        // });
      }
    },
    staDetialHide() {
      this.$refs.staDetialPopup.hide();
    },
    stationHide() {
      this.paper.select("#temp_g") ? this.paper.select("#temp_g").remove() : "";
      this.$refs.stationPopup.hide();
    },
    toFastRoad() {
      // if (this.sessionUserInfo && this.sessionUserInfo.unionid) {
      localStorage.setItem("mylatitude", this.latitude);
      localStorage.setItem("mylongitude", this.longitude);
      localStorage.setItem("myAddress", this.address);
      if (window.roadBaiduClick && this.$route.params.browser.versions.ios) {
        window.roadBaiduClick("40");
      } else if (
        window.liaoningactivity &&
        window.liaoningactivity.roadBaiduClick &&
        this.$route.params.browser.versions.android
      ) {
        window.liaoningactivity.roadBaiduClick("40");
      }
      console.log(222);

      if (this.$route.query.comeFrom == 1) {
        if (this.browser.versions.ios) {
          window.toWebH5(
            `https://app.ln-gst.com/sessionSVGVue/index.html#/fastChoose?comeFrom=${this.$route.query.comeFrom}`
          );
          // window.toWebH5(
          //   `https://app.ln-gst.com/sessionSVGVueTest/index.html#/fastChoose?comeFrom=${this.$route.query.comeFrom}`
          // );
        } else if (this.browser.versions.android) {
          window.uroadhtml.toWebH5(
            `https://app.ln-gst.com/sessionSVGVue/index.html#/fastChoose?comeFrom=${this.$route.query.comeFrom}`
          );
          // window.uroadhtml.toWebH5(
          //   `https://app.ln-gst.com/sessionSVGVueTest/index.html#/fastChoose?comeFrom=${this.$route.query.comeFrom}`
          // );
        }
      } else {
        this.$router.push(`/fastChoose`);
      }
      // } else {
      //   this.$createDialog({
      //     type: "confirm",
      //     // icon: 'cubeic-alert',
      //     title: "提示",
      //     content: "您还没有登录，是否先去登录？",
      //     confirmBtn: {
      //       text: "确定",
      //       active: true,
      //       disabled: false,
      //       href: "javascript:;",
      //     },
      //     cancelBtn: {
      //       text: "取消",
      //       active: false,
      //       disabled: false,
      //       href: "javascript:;",
      //     },
      //     onConfirm: () => {
      //       if (this.browser.versions.ios) {
      //         window.uroadplus_login();
      //       } else if (this.browser.versions.android) {
      //         window.uroadhtml.uroadplus_login();
      //       }
      //     },
      //     onCancel: () => {},
      //   }).show();
      // }
    },
    fujinFun() {
      this.fujinShouList();
      this.fujinFuList();
      this.fujinYouList();
      this.fujinIndex = 1;
      this.$refs.fujinPopup.show();
      if (this.$route.params.browser.versions.weixin) {
        return;
      } else if (
        window.roadBaiduClick &&
        this.$route.params.browser.versions.ios
      ) {
        window.roadBaiduClick("30");
      } else if (
        window.liaoningactivity &&
        window.liaoningactivity.roadBaiduClick &&
        this.$route.params.browser.versions.android
      ) {
        window.liaoningactivity.roadBaiduClick("30");
      }
      console.log(222);
    },
    fujinShouList() {
      let loadingToast = this.$createToast({
        txt: "加载中...",
        mask: true
      }).show();
      this.$Post(
        "highwayInfoSVGWeb/fetchNearbyTollstation",
        {
          poiid: "",
          longitude: this.longitude,
          latitude: this.latitude
        },
        ({ data }) => {
          // 测试用 
          // data[1].stationstatus = '封闭';
          data.forEach(element => {
            let str = element.stationstatus.replace('封闭', '关闭');
            element.stationstatus = str;
          });
          this.staTabList = data;

          loadingToast.hide();
        },
        err => {
          this.$alertShow(err.msg);
        },
        true
      );
    },
    fujinFuList() {
      let loadingToast = this.$createToast({
        txt: "加载中...",
        mask: true
      }).show();
      this.$Post(
        "highwayInfoSVGWeb/fetchService",
        {
          longitude: this.longitude,
          latitude: this.latitude,
          limit: 5
        },
        ({ data }) => {
          //测试用
          // data[0].servicestatus = 'sdf' 
          this.fuwuTabList = data;
          loadingToast.hide();
        },
        err => {
          this.$alertShow(err.msg);
        },
        true
      );
    },
    fujinYouList() {
      let loadingToast = this.$createToast({
        txt: "加载中...",
        mask: true
      }).show();
      this.$Post(
        "highwayInfoSVGWeb/fetchNearGasStation",
        {
          longitude: this.longitude,
          latitude: this.latitude
        },
        ({ data }) => {
          this.jiayTabList = data;
          loadingToast.hide();
        },
        err => {
          this.$alertShow(err.msg);
        },
        true
      );
    },
    fuToStation(obj) {
      let loadingToast = this.$createToast({
        txt: "加载中...",
        mask: true
      }).show();
      this.showAlertStation(obj, loadingToast);
    },
    fuToFuwu(obj) {
      // let loadingToast = this.$createToast({
      //   txt: "加载中...",
      //   mask: true
      // }).show();
      // this.showAlertFu(obj, loadingToast);
       this.getFuwuquData(obj);
    },

    fujinHide() {
      this.$refs.fujinPopup.hide();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.svgCon {
  height: 100%;
}

// /deep/ .cube-tab-bar {
//   // width: 1.95rem;
//   width: 2.5rem;
// }

/deep/ .cube-tab {
  font-size: 0.14rem;
  // width: 0.48rem;
  margin-right: 0.17rem;
}

/deep/ .cube-tab_active div {
  color: #199ef4;
  font-weight: bolder;
}

/deep/ .cube-tab-bar-slider {
  background-color: #199ef4;
}

/deep/ .cube-scroll-content {
  display: inline-block;
}

.stationDetialSty /deep/ .cube-scroll-wrapper {
  position: fixed;
  height: 75%;
  overflow: hidden;
  bottom: 0;
  z-index: 15;
  background-color: #fff;
}

.tipsty {
  padding: 0.01rem 0.07rem;
  border-radius: 0.085rem;
  font-size: 0.12rem;
}

.yellow {
  border: 0.01rem solid #ffa012;
  color: #ffa012 !important;
}

.green {
  border: 0.01rem solid #01874f;
  color: #01874f !important;
}

.reds {
  color: #b20000 !important;
  border: 0.01rem solid #b20000;
}

.black {
  color: #333333 !important;
  border: none;
}

.roadPlan {
  position: fixed;
  bottom: 0.35rem;
  width: 1.5rem;
  height: 0.38rem;
  background: url("../assets/img/luxianguihua.png") no-repeat;
  background-size: contain;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 1.12rem;

  div {
    font-size: 0.13rem;
    font-weight: bolder;
    color: #fff;
  }
}

.menu_box {
  .aside {
    position: fixed;
    color: #666666;
    border-radius: 0.04rem;
    z-index: 10;
    background-color: rgba(255, 255, 255);
    cursor: pointer;
    box-shadow: 0px 0px 4px 4px #f3f3f3;
    top: 0.4rem;
    right: 0.1rem;
    width: 0.46rem;
    text-align: center;
    padding: 0.07rem 0;

    img {
      width: 0.2rem;
      height: 0.2rem;
      margin: 0 auto;
      /* margin-bottom:10px; */
    }

    p {
      font-size: 0.1rem !important;
    }
  }

  .aside_menuBG {
    position: fixed;
    background: rgba(0, 0, 0, 0.5);
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 10;
  }

  .aside_menu {
    position: absolute;
    background-color: #fff;
    width: 2.2rem;
    top: 0.4rem;
    right: 0.8rem;
    border-radius: 0.04rem;
    z-index: 11;
    overflow: hidden;

    .title {
      height: 0.3rem;
      line-height: 0.3rem;
      font-size: 0.12rem;
      padding-left: 0.12rem;
      background: rgba(246, 246, 246, 1);
      color: #666666;
    }

    ul {
      display: flex;
      flex-wrap: wrap;
      padding-bottom: 0.13rem;

      li {
        margin-top: 0.16rem;
        text-align: center;
        font-size: 0.12rem;
        color: #333333;
        flex: 0 0 33.3%;

        img {
          width: 0.28rem;
          height: 0.28rem;
          margin-bottom: 0.06rem;
        }
      }
    }
  }
}

.qiTips {
  position: fixed;
  top: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999999;

  .qiConBg {
    width: 80%;
    height: 1.54rem;
    left: 0.1rem;
    position: absolute;
    top: 0.88rem;
    z-index: 1000;
  }

  .qiCon {
    width: 78%;
    height: 1.54rem;
    left: 0.1rem;
    background-size: 100% 100%;
    position: absolute;
    top: 1.06rem;
    text-align: center;
    z-index: 1001;

    .titles {
      font-size: 0.16rem;
      font-weight: 400;
    }

    .con {
      line-height: 1.5;
      color: #787878;
      padding: 0 0.06rem;
      font-size: 0.12rem;
      margin-top: 0.08rem;
    }

    .iknow {
      padding: 0.09rem 0.16rem;
      border-radius: 0.195rem;
      border: 0.01rem solid #ebebeb;
      width: 0.8rem;
      margin: 0.15rem auto;
      font-size: 0.12rem;
    }
  }
}

.qiTipIcon {
  position: absolute;
  right: 0.1rem;
  top: 0.88rem;
}

#staDetialPopup /deep/ .cube-popup-content {
  max-height: 70%;
  overflow-y: scroll;
}

// .scroll-view {
//   touch-action: none;
//   position: fixed;
//   top: 0;
//   bottom: 0;
//   left: 0;
//   right: 0;
//   overflow: hidden;
// }
// .scroll-view > div {
//   min-height: 101%;
//   position: absolute;
//   z-index: 1;
//   -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
//   width: 100%;
//   -webkit-transform: translateZ(0);
//   -moz-transform: translateZ(0);
//   -ms-transform: translateZ(0);
//   -o-transform: translateZ(0);
//   transform: translateZ(0);
//   -webkit-touch-callout: none;
//   -webkit-user-select: none;
//   -moz-user-select: none;
//   -ms-user-select: none;
//   user-select: none;
//   -webkit-text-size-adjust: none;
//   -moz-text-size-adjust: none;
//   -ms-text-size-adjust: none;
//   -o-text-size-adjust: none;
//   text-size-adjust: none;
// }
.stationCon1 {
  height: 75vh;
  overflow-y: auto;
  width: 100vw;
  background: #F8F8F8;
  border-radius: 0.12rem 0.12rem 0rem 0rem;
  padding: .14rem .15rem;
  box-sizing: border-box;

  &::-webkit-scrollbar {
    display: none;
  }

  .nearStation {
    margin-top: .1rem;
    background: #FFFFFF;
    border-radius: 0.08rem;
    padding: .11rem .1rem;
    box-sizing: border-box;

    .nearStaTitle {
      font-size: .17rem;
      color: #333333;
      font-weight: bold;
      display: flex;
      align-items: center;

      &::before {
        content: "";
        display: block;
        width: 0.04rem;
        height: 0.11rem;
        background: linear-gradient(180deg, #0081F6 0%, #1EB5FF 100%);
        border-radius: 0.02rem;
        margin-right: .05rem;
      }
    }

    ul {
      margin-top: .02rem;

      li {
        display: flex;
        align-items: center;
        padding: .11rem 0;
        border-bottom: 0.01rem solid #EEEEEE;

        .stationName {
          width: 75%;
          margin-left: .06rem;

          .stationStatus {
            margin-left: .08rem;
            width: 0.26rem;
            line-height: 0.16rem;
            height: 0.16rem;
            background: #E9F8EE;
            color: #4AC475;
            text-align: center;

            span {
              font-weight: bold;
              display: block;
              font-size: 0.12rem;
              transform: scale(11/12);
            }
          }

          .stationNameText {
            display: flex;
            align-items: center;
            font-size: .16rem;
            font-weight: bold;
          }

          .staAddress {
            margin-top: .1rem;
            font-size: .14rem;
            width: 2.08rem;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
        }

        .daohang {
          text-align: center;

          .disCon {
            font-size: 0.11rem;
            margin-top: .08rem;
          }
        }
      }
    }
  }
}

.stationCon {
  background: #fff;
  padding: 0.14rem 0.12rem;
  border-radius: 0.12rem 0.12rem 0rem 0rem;

  .titleCon {
    display: flex;

    .sjName {
      width: 85%;
      margin-left: 0.13rem;

      .sjNameText {
        font-size: 0.16rem;
        font-weight: 600;
      }

      .tipsty {
        padding: 0 0.07rem;
        border-radius: 0.085rem;
        font-size: 0.12rem;
      }

      .address {
        margin-top: 0.07rem;
        font-size: 0.14rem;
        color: #6b6b6b;
      }
    }

    .closePop {
      color: #c8c8c8;
      float: right;
    }
  }

  .mainCon {
    font-size: 0.14rem;
    color: #6b6b6b;
    margin: 0.1rem 0;
  }

  .mainPot {
    ul {
      display: flex;
      justify-content: space-around;
      text-align: center;

      li {
        width: 25%;
      }

      .valCon {
        font-weight: bold;
        font-size: 0.14rem;
        margin: 0.12rem 0;
      }

      .keyCon {
        font-size: 0.12rem;
        font-weight: 400;
      }
    }
  }

  .stationTitle {
    display: flex;
    position: relative;
    border-bottom: 0.01rem solid #f6f6f6;
    padding-bottom: 0.1rem;
    align-items: center;

    .stationName {
      margin-left: 0.03rem;
      width: 80%;
      line-height: 1.5;

      .stationNameText {
        font-size: 0.16rem;
        font-weight: 500;
      }

      .stationRoadname {
        font-size: 0.13rem;
      }

      .staAddress {
        font-size: 0.13rem;
        color: #9b9b9b;
      }
    }

    .next {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .toDetial {
      margin-left: 0.1rem;
    }

    .daohang {
      /*position: absolute;*/
      // top: 0.38rem;
      /*top: -0.2rem;*/
      /*right: 0.2rem;*/
      font-size: 0.11rem;
      text-align: center;
      color: #3d3d3d;
    }
  }

  .stationStatus {
    ul {
      display: flex;
      flex-wrap: wrap;
      text-align: center;
      line-height: 1.5;

      li {
        width: 50%;
        padding: 0.1rem 0;
        border-top: 0.01rem solid #f6f6f6;

        .dirSty {
          font-size: 0.16rem;
        }

        .tipsTag,
        .unAllow {
          font-size: 0.12rem;
          color: #ffa012;
        }
      }
    }
  }

  .staDetialTitle {
    >div {
      display: flex;
    }

    >div:first-child {
      margin-bottom: 0.09rem;
    }

    .stationName {
      margin-left: 0.03rem;
      width: 80%;
      line-height: 1.5;

      .stationNameText {
        font-size: 0.16rem;
        font-weight: 500;
      }

      .stationRoadname {
        font-size: 0.13rem;
      }

      .staAddress {
        font-size: 0.13rem;
        color: #9b9b9b;
      }
    }
  }

  .grayBg {
    height: 0.11rem;
    width: 100%;
    margin: 0.2rem 0;
    background-color: #f6f6f6;
  }

  .staDetialStatus {
    .staStaTitle {
      font-size: 0.16rem;
      font-weight: 600;
      text-align: center;
    }

    ul {
      display: flex;
      flex-wrap: wrap;
      text-align: center;
      line-height: 1.5;
      margin-top: 0.2rem;

      li {
        width: 49%;
        padding: 0.1rem 0;

        .dirSty {
          font-size: 0.16rem;
        }

        .tipsTag,
        .unAllow {
          font-size: 0.12rem;
          color: #ffa012;
        }

        .yellow {
          border: 0.01rem solid #ffa012;
          color: #ffa012;
        }

        .green {
          border: 0.01rem solid #01874f;
          color: #01874f;
        }
      }

      li:first-child {
        border-bottom: 0.01rem solid #f6f6f6;
        border-right: 0.01rem solid #f6f6f6;
      }

      li:last-child {
        border-top: 0.01rem solid #f6f6f6;
        border-left: 0.01rem solid #f6f6f6;
      }
    }
  }


}

.qixiangCon {
  background: #fff;
  padding: 20px 10px;
  width: 100%;

  .qixiangTitle {
    display: flex;

    .stationName {
      font-size: 14px;
    }
  }

  .qixiangMain {
    display: flex;

    .temNum {
      font-size: 0.4rem;
      font-weight: 600;
      width: 20%;
    }

    .mianDe {
      line-height: 2;
      width: 60%;

      >div:first-child {
        font-size: 0.12rem;
      }

      .windCon {
        font-size: 0.11rem;
        color: #a5adb7;
      }

      .mianCon {
        font-size: 0.1rem;
        color: #3d3d3d;
      }
    }
  }
}

.fuwuCon {
  background-color: #fff;
  padding: 0.2rem 0.1rem;

  .fuwuTitle {
    display: flex;
    position: relative;

    .stationName {
      line-height: 1.5;
      margin-left: 0.1rem;

      >div:first-child {
        font-size: 0.16rem;
      }

      >div:nth-child(2) {
        font-size: 0.13rem;
      }

      >div:last-child {
        font-size: 0.13rem;
        color: #9b9b9b;
      }
    }

    .daohang {
      position: absolute;
      top: -0.38rem;
      right: 0.2rem;
      font-size: 0.11rem;
      text-align: center;
      color: #3d3d3d;
    }
  }

  .fuwuMain {
    .statusList {
      font-size: 0.12rem;
      border-top: 0.01rem solid #f6f6f6;
      line-height: 2;

      .statusTitle {
        text-align: center;
        font-size: 0.13rem;
      }

      .statusItem {
        ul {
          display: flex;
          justify-content: space-around;

          li {
            text-align: center;

            img {
              width: 0.16rem;
              height: 0.16rem;
            }
          }
        }
      }
    }
  }
}

.fuJinCon {
  background-color: #fff;
  padding: 0.2rem 0.1rem;
  border-radius: 0.12rem 0.12rem 0 0;

  .tabCon {
    margin-top: 0.12rem;

    .staList {

      // overflow-x: scroll;
      ul {
        // width: 1250px;
        display: flex;
        white-space: nowrap;

        li {
          display: inline-flex;
          min-width: 2.4rem;
          border: 0.01rem solid rgba(224, 222, 222, 1);
          margin-right: 0.1rem;
          padding: 0.1rem 0.06rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue